const T = {
  tabletMin: 600,
  laptopMin: 1024,
  desktopMin: 1440,
  wideScreenMin: 1640
}, v = {
  mobile: `(max-width: ${T.tabletMin - 1}px)`,
  tabletAndUp: `(min-width: ${T.tabletMin}px)`,
  laptopAndUp: `(min-width: ${T.laptopMin}px)`,
  desktopAndUp: `(min-width: ${T.desktopMin}px)`,
  wideScreenAndUp: `(min-width: ${T.wideScreenMin}px)`
}, o = {
  primitive: {
    color: {
      fordBlue: {
        100: {
          value: "#e6e6ef",
          type: "color",
          description: "This is the Ford Blue brand color with 90% white added."
        },
        200: {
          value: "#cccede",
          type: "color",
          description: "This is the Ford Blue brand color with 80% white added."
        },
        300: {
          value: "#b3b5ce",
          type: "color",
          description: "This is the Ford Blue brand color with 70% white added."
        },
        400: {
          value: "#999dbd",
          type: "color",
          description: "This is the Ford Blue brand color with 60% white added."
        },
        500: {
          value: "#8084ad",
          type: "color",
          description: "This is the Ford Blue brand color with 50% white added."
        },
        600: {
          value: "#666b9d",
          type: "color",
          description: "This is the Ford Blue brand color with 40% white added."
        },
        700: {
          value: "#4d538c",
          type: "color",
          description: "This is the Ford Blue brand color with 30% white added."
        },
        800: {
          value: "#333a7c",
          type: "color",
          description: "This is the Ford Blue brand color with 20% white added."
        },
        900: {
          value: "#1a226b",
          type: "color",
          description: "This is the Ford Blue brand color with 10% white added."
        },
        1e3: {
          value: "#00095b",
          type: "color",
          description: "This is the Ford Blue brand color."
        },
        1100: {
          value: "#000852",
          type: "color",
          description: "This is the Ford Blue brand color with 10% black added."
        },
        1200: {
          value: "#000749",
          type: "color",
          description: "This is the Ford Blue brand color with 20% black added."
        },
        1300: {
          value: "#000640",
          type: "color",
          description: "This is the Ford Blue brand color with 30% black added."
        },
        1400: {
          value: "#00052E",
          type: "color",
          description: "This is the Ford Blue brand color with 50% black added."
        }
      },
      grabber: {
        100: {
          value: "#e8e6fe",
          type: "color",
          description: "This is the Ford Grabber brand color with 90% white added."
        },
        200: {
          value: "#d1ccfd",
          type: "color",
          description: "This is the Ford Grabber brand color with 80% white added."
        },
        300: {
          value: "#b9b3fc",
          type: "color",
          description: "This is the Ford Grabber brand color with 70% white added."
        },
        400: {
          value: "#a299fb",
          type: "color",
          description: "This is the Ford Grabber brand color with 60% white added."
        },
        500: {
          value: "#8b80fa",
          type: "color",
          description: "This is the Ford Grabber brand color with 50% white added."
        },
        600: {
          value: "#7466f8",
          type: "color",
          description: "This is the Ford Grabber brand color with 40% white added."
        },
        700: {
          value: "#5d4df7",
          type: "color",
          description: "This is the Ford Grabber brand color with 30% white added."
        },
        800: {
          value: "#4533f6",
          type: "color",
          description: "This is the Ford Grabber brand color with 20% white added."
        },
        900: {
          value: "#2e19f5",
          type: "color",
          description: "This is the Ford Grabber brand color with 10% white added."
        },
        1e3: {
          value: "#1700f4",
          type: "color",
          description: "This is the Ford Grabber brand color."
        },
        1100: {
          value: "#1500dc",
          type: "color",
          description: "This is the Ford Grabber brand color with 10% black added."
        },
        1200: {
          value: "#1200c3",
          type: "color",
          description: "This is the Ford Grabber brand color with 20% black added."
        },
        1300: {
          value: "#1000AB",
          type: "color",
          description: "This is the Ford Grabber brand color with 30% black added."
        },
        1400: {
          value: "#0C007A",
          type: "color",
          description: "This is the Ford Grabber brand color with 50% black added."
        }
      },
      skyview: {
        100: {
          value: "#e6f1fd",
          type: "color",
          description: "This is the Ford Skyview brand color with 90% white added."
        },
        200: {
          value: "#cde2fc",
          type: "color",
          description: "This is the Ford Skyview brand color with 80% white added."
        },
        300: {
          value: "#b4d4fa",
          type: "color",
          description: "This is the Ford Skyview brand color with 70% white added."
        },
        400: {
          value: "#9bc5f9",
          type: "color",
          description: "This is the Ford Skyview brand color with 60% white added."
        },
        500: {
          value: "#83b7f7",
          type: "color",
          description: "This is the Ford Skyview brand color with 50% white added."
        },
        600: {
          value: "#6aa9f5",
          type: "color",
          description: "This is the Ford Skyview brand color with 40% white added."
        },
        700: {
          value: "#519af4",
          type: "color",
          description: "This is the Ford Skyview brand color with 30% white added."
        },
        800: {
          value: "#388cf2",
          type: "color",
          description: "This is the Ford Skyview brand color with 20% white added."
        },
        900: {
          value: "#1f7df1",
          type: "color",
          description: "This is the Ford Skyview brand color with 10% white added."
        },
        1e3: {
          value: "#066fef",
          type: "color",
          description: "This is the Ford Skyview brand color."
        },
        1100: {
          value: "#0564d7",
          type: "color",
          description: "This is the Ford Skyview brand color with 10% black added."
        },
        1200: {
          value: "#0559bf",
          type: "color",
          description: "This is the Ford Skyview brand color with 20% black added."
        },
        1300: {
          value: "#044EA7",
          type: "color",
          description: "This is the Ford Skyview brand color with 30% black added."
        },
        1400: {
          value: "#033878",
          type: "color",
          description: "This is the Ford Skyview brand color with 50% black added."
        }
      },
      neutral: {
        100: {
          value: "#fafafb",
          type: "color",
          description: "This is the Twilight brand color with 90% white added."
        },
        200: {
          value: "#f5f6f7",
          type: "color",
          description: "This is the Twilight brand color with 80% white added."
        },
        300: {
          value: "#e6e8ea",
          type: "color",
          description: "This is the Twilight brand color with 70% white added."
        },
        400: {
          value: "#d1d5d9",
          type: "color",
          description: "This is the Twilight brand color with 60% white added."
        },
        500: {
          value: "#9ca3ad",
          type: "color",
          description: "This is the Twilight brand color with 50% white added."
        },
        600: {
          value: "#6b7786",
          type: "color",
          description: "This is the Twilight brand color with 40% white added."
        },
        700: {
          value: "#4d5b6d",
          type: "color",
          description: "This is the Twilight brand color with 30% white added."
        },
        800: {
          value: "#38485c",
          type: "color",
          description: "This is the Twilight brand color with 20% white added."
        },
        900: {
          value: "#1f3047",
          type: "color",
          description: "This is the Twilight brand color with 10% white added."
        },
        1e3: {
          value: "#00142e",
          type: "color",
          description: "This is the Twilight brand color."
        },
        1100: {
          value: "#001025",
          type: "color",
          description: "This is the Twilight brand color with 10% black added."
        },
        1200: {
          value: "#000000",
          type: "color",
          description: "Black 100%"
        },
        "000": {
          value: "#ffffff",
          type: "color",
          description: "White 100%"
        }
      },
      green: {
        100: {
          value: "#e6f3e6",
          type: "color",
          description: "This is the green color with 90% white added."
        },
        200: {
          value: "#cce6cc",
          type: "color",
          description: "This is the green color with 80% white added."
        },
        300: {
          value: "#b3dab3",
          type: "color",
          description: "This is the green color with 70% white added."
        },
        400: {
          value: "#99cd99",
          type: "color",
          description: "This is the green color with 60% white added."
        },
        500: {
          value: "#80c180",
          type: "color",
          description: "This is the green color with 50% white added."
        },
        600: {
          value: "#66b466",
          type: "color",
          description: "This is the green color with 40% white added."
        },
        700: {
          value: "#4da84d",
          type: "color",
          description: "This is the green color with 30% white added."
        },
        800: {
          value: "#339b33",
          type: "color",
          description: "This is the green color with 20% white added."
        },
        900: {
          value: "#198f19",
          type: "color",
          description: "This is the green color with 10% white added."
        },
        1e3: {
          value: "#008200",
          type: "color",
          description: "This is the green colour."
        },
        1100: {
          value: "#007500",
          type: "color",
          description: "This is the green color with 10% black added."
        },
        1200: {
          value: "#006800",
          type: "color",
          description: "This is the green color with 20% black added."
        },
        1300: {
          value: "#005B00",
          type: "color",
          description: "This is the green color with 30% black added."
        },
        1400: {
          value: "#004100",
          type: "color",
          description: "This is the green color with 50% black added."
        }
      },
      amber: {
        100: {
          value: "#f8ede6",
          type: "color",
          description: "This is the amber color with 90% white added."
        },
        200: {
          value: "#f1dccc",
          type: "color",
          description: "This is the amber color with 80% white added."
        },
        300: {
          value: "#eacab3",
          type: "color",
          description: "This is the amber color with 70% white added."
        },
        400: {
          value: "#e3b899",
          type: "color",
          description: "This is the amber color with 60% white added."
        },
        500: {
          value: "#dda780",
          type: "color",
          description: "This is the amber color with 50% white added."
        },
        600: {
          value: "#d69566",
          type: "color",
          description: "This is the amber color with 40% white added."
        },
        700: {
          value: "#cf834d",
          type: "color",
          description: "This is the amber color with 30% white added."
        },
        800: {
          value: "#c87133",
          type: "color",
          description: "This is the amber color with 20% white added."
        },
        900: {
          value: "#c16019",
          type: "color",
          description: "This is the amber color with 10% white added."
        },
        1e3: {
          value: "#ba4e00",
          type: "color",
          description: "This is the amber color."
        },
        1100: {
          value: "#a74600",
          type: "color",
          description: "This is the amber color with 10% black added."
        },
        1200: {
          value: "#953e00",
          type: "color",
          description: "This is the amber color with 20% black added."
        },
        1300: {
          value: "#823700",
          type: "color",
          description: "This is the amber color with 30% black added."
        },
        1400: {
          value: "#5D2700",
          type: "color",
          description: "This is the amber color with 50% black added."
        }
      },
      red: {
        100: {
          value: "#fbeae7",
          type: "color",
          description: "This is the red color with 90% white added."
        },
        200: {
          value: "#f7d5ce",
          type: "color",
          description: "This is the red color with 80% white added."
        },
        300: {
          value: "#f3c0b6",
          type: "color",
          description: "This is the red color with 70% white added."
        },
        400: {
          value: "#efab9d",
          type: "color",
          description: "This is the red color with 60% white added."
        },
        500: {
          value: "#eb9685",
          type: "color",
          description: "This is the red color with 50% white added."
        },
        600: {
          value: "#e6816c",
          type: "color",
          description: "This is the red color with 40% white added."
        },
        700: {
          value: "#e26c54",
          type: "color",
          description: "This is the red color with 30% white added."
        },
        800: {
          value: "#de573b",
          type: "color",
          description: "This is the red color with 20% white added."
        },
        900: {
          value: "#da4223",
          type: "color",
          description: "This is the red color with 10% white added."
        },
        1e3: {
          value: "#d62d0a",
          type: "color",
          description: "This is the red color."
        },
        1100: {
          value: "#c12909",
          type: "color",
          description: "This is the red color with 10% black added."
        },
        1200: {
          value: "#ab2408",
          type: "color",
          description: "This is the red color with 20% black added."
        },
        1300: {
          value: "#962007",
          type: "color",
          description: "This is the red color with 30% black added."
        },
        1400: {
          value: "#6B1705",
          type: "color",
          description: "This is the red color with 50% black added."
        }
      },
      opacity: {
        light: {
          10: {
            value: "#00142e14",
            type: "color"
          },
          20: {
            value: "#00142e33",
            type: "color"
          },
          30: {
            value: "#00142e4d",
            type: "color"
          },
          40: {
            value: "#00142e66",
            type: "color"
          },
          50: {
            value: "#00142e80",
            type: "color"
          },
          60: {
            value: "#00142e99",
            type: "color"
          },
          70: {
            value: "#00142eb3",
            type: "color"
          },
          80: {
            value: "#00142ecc",
            type: "color"
          },
          90: {
            value: "#00142ee6",
            type: "color"
          },
          100: {
            value: "#00142e",
            type: "color"
          },
          "00": {
            value: "#00142e00",
            type: "color"
          }
        },
        dark: {
          10: {
            value: "#ffffff1a",
            type: "color"
          },
          20: {
            value: "#ffffff33",
            type: "color"
          },
          30: {
            value: "#ffffff4d",
            type: "color"
          },
          40: {
            value: "#ffffff66",
            type: "color"
          },
          50: {
            value: "#ffffff80",
            type: "color"
          },
          60: {
            value: "#ffffff99",
            type: "color"
          },
          70: {
            value: "#ffffffb3",
            type: "color"
          },
          80: {
            value: "#ffffffcc",
            type: "color"
          },
          90: {
            value: "#ffffffe6",
            type: "color"
          },
          100: {
            value: "#ffffff",
            type: "color"
          },
          "00": {
            value: "#ffffff00",
            type: "color"
          }
        }
      },
      yellow: {
        100: {
          value: "#FFF9E5",
          type: "color",
          description: "This is the yellow color with 90% white added."
        },
        200: {
          value: "#FFF2CC",
          type: "color",
          description: "This is the yellow color with 80% white added."
        },
        300: {
          value: "#FFECB2",
          type: "color",
          description: "This is the yellow color with 70% white added."
        },
        400: {
          value: "#FFE699",
          type: "color",
          description: "This is the yellow color with 60% white added."
        },
        500: {
          value: "#FFDF80",
          type: "color",
          description: "This is the yellow color with 50% white added."
        },
        600: {
          value: "#FFD966",
          type: "color",
          description: "This is the yellow color with 40% white added."
        },
        700: {
          value: "#FFD34D",
          type: "color",
          description: "This is the yellow color with 30% white added."
        },
        800: {
          value: "#FFCD33",
          type: "color",
          description: "This is the yellow color with 20% white added."
        },
        900: {
          value: "#FFC61A",
          type: "color",
          description: "This is the yellow color with 10% white added."
        },
        1e3: {
          value: "#FFC000",
          type: "color",
          description: "This is the yellow colour."
        },
        1100: {
          value: "#E5AD00",
          type: "color",
          description: "This is the yellow color with 10% black added."
        },
        1200: {
          value: "#CC9A00",
          type: "color",
          description: "This is the yellow color with 20% black added."
        },
        1300: {
          value: "#B28600",
          type: "color",
          description: "This is the yellow color with 30% black added."
        },
        1400: {
          value: "#664D00",
          type: "color",
          description: "This is the yellow color with 50% black added."
        }
      },
      twilight: {
        100: {
          value: "#fafafb",
          type: "color",
          description: "This is the Twilight brand color with 90% white added."
        },
        200: {
          value: "#f5f6f7",
          type: "color",
          description: "This is the Twilight brand color with 80% white added."
        },
        300: {
          value: "#e6e8ea",
          type: "color",
          description: "This is the Twilight brand color with 70% white added."
        },
        400: {
          value: "#d1d5d9",
          type: "color",
          description: "This is the Twilight brand color with 60% white added."
        },
        500: {
          value: "#9ca3ad",
          type: "color",
          description: "This is the Twilight brand color with 50% white added."
        },
        600: {
          value: "#6b7786",
          type: "color",
          description: "This is the Twilight brand color with 40% white added."
        },
        700: {
          value: "#4d5b6d",
          type: "color",
          description: "This is the Twilight brand color with 30% white added."
        },
        800: {
          value: "#38485c",
          type: "color",
          description: "This is the Twilight brand color with 20% white added."
        },
        900: {
          value: "#1f3047",
          type: "color",
          description: "This is the Twilight brand color with 10% white added."
        },
        1e3: {
          value: "#00142e",
          type: "color",
          description: "This is the Twilight brand color."
        },
        1100: {
          value: "#001025",
          type: "color",
          description: "This is the Twilight brand color with 10% black added."
        },
        1200: {
          value: "#000000",
          type: "color",
          description: "Black 100%"
        },
        1300: {
          value: "#000E20",
          type: "color",
          description: "This is the Ford Twilight brand color with 30% black added."
        },
        1400: {
          value: "#000A17",
          type: "color",
          description: "This is the Ford Twilight brand color with 50% black added."
        },
        "000": {
          value: "#ffffff",
          type: "color",
          description: "White 100%"
        }
      },
      teal: {
        800: {
          value: "#00A5A5",
          type: "color"
        },
        900: {
          value: "#088D95",
          type: "color"
        },
        1e3: {
          value: "#0C7483",
          type: "color",
          description: "Teal base color."
        },
        1100: {
          value: "#0b6778",
          type: "color"
        },
        1200: {
          value: "#085A6E",
          type: "color"
        },
        1300: {
          value: "#034c60",
          type: "color"
        },
        1400: {
          value: "#003F54",
          type: "color"
        }
      },
      orange: {
        800: {
          value: "#E67205",
          type: "color",
          description: "Orange base color"
        },
        900: {
          value: "#C85E0E",
          type: "color"
        },
        1e3: {
          value: "#A84A0E",
          type: "color"
        },
        1100: {
          value: "#973F0C",
          type: "color"
        },
        1200: {
          value: "#86350A",
          type: "color"
        },
        1300: {
          value: "#742A06",
          type: "color"
        },
        1400: {
          value: "#612004",
          type: "color"
        }
      },
      magenta: {
        800: {
          value: "#F644BB",
          type: "color"
        },
        900: {
          value: "#DB199A",
          type: "color",
          description: "Magenta base color"
        },
        1e3: {
          value: "#B11C7E",
          type: "color"
        },
        1100: {
          value: "#981A6C",
          type: "color"
        },
        1200: {
          value: "#7F165B",
          type: "color"
        },
        1300: {
          value: "#650F48",
          type: "color"
        },
        1400: {
          value: "#4B0735",
          type: "color"
        }
      },
      purple: {
        800: {
          value: "#BB6FF9",
          type: "color"
        },
        900: {
          value: "#A15BE0",
          type: "color"
        },
        1e3: {
          value: "#8746C6",
          type: "color",
          description: "Purple base color"
        },
        1100: {
          value: "#793ab8",
          type: "color"
        },
        1200: {
          value: "#6B2EAA",
          type: "color"
        },
        1300: {
          value: "#5D1F9C",
          type: "color"
        },
        1400: {
          value: "#50098E",
          type: "color"
        }
      }
    },
    size: {
      x1: {
        value: "4px",
        type: "sizing",
        description: "4px Radius"
      },
      "2x": {
        value: "8px",
        type: "sizing",
        description: "8px size"
      },
      "3x": {
        value: "12px",
        type: "sizing",
        description: "12px size"
      },
      "4x": {
        value: "16px",
        type: "sizing",
        description: "16px size"
      },
      "5x": {
        value: "20px",
        type: "sizing",
        description: "20px size"
      },
      "6x": {
        value: "24px",
        type: "sizing",
        description: "24px size"
      },
      "7x": {
        value: "28px",
        type: "sizing",
        description: "28px size"
      },
      "8x": {
        value: "32px",
        type: "sizing",
        description: "32px size"
      },
      "10x": {
        value: "40px",
        type: "sizing",
        description: "40px size"
      },
      "12x": {
        value: "48px",
        type: "sizing",
        description: "48px size"
      },
      "15x": {
        value: "60px",
        type: "sizing",
        description: "60px size"
      },
      "16x": {
        value: "64px",
        type: "sizing",
        description: "64px size"
      }
    },
    space: {
      "1x": {
        value: "4px",
        type: "spacing",
        description: "4px spacing"
      },
      "2x": {
        value: "8px",
        type: "spacing",
        description: "8px spacing"
      },
      "3x": {
        value: "12px",
        type: "spacing",
        description: "12px spacing"
      },
      "4x": {
        value: "16px",
        type: "spacing",
        description: "16px spacing"
      },
      "5x": {
        value: "20px",
        type: "spacing",
        description: "20px spacing"
      },
      "6x": {
        value: "24px",
        type: "spacing",
        description: "24px spacing"
      },
      "7x": {
        value: "28px",
        type: "spacing",
        description: "28px spacing"
      },
      "8x": {
        value: "32px",
        type: "spacing",
        description: "32px spacing"
      },
      "10x": {
        value: "40px",
        type: "spacing",
        description: "40px spacing"
      },
      "12x": {
        value: "48px",
        type: "spacing",
        description: "48px spacing"
      },
      "15x": {
        value: "60px",
        type: "spacing",
        description: "60px spacing"
      },
      "16x": {
        value: "64px",
        type: "spacing",
        description: "64px spacing"
      }
    },
    radius: {
      "1x": {
        value: "4px",
        type: "borderRadius",
        description: "4px radius"
      },
      "2x": {
        value: "8px",
        type: "borderRadius",
        description: "8px radius"
      },
      "3x": {
        value: "12px",
        type: "borderRadius",
        description: "12px radius"
      },
      "4x": {
        value: "16px",
        type: "borderRadius",
        description: "16px radius"
      },
      "5x": {
        value: "20px",
        type: "borderRadius",
        description: "20px radius"
      },
      "6x": {
        value: "24px",
        type: "borderRadius",
        description: "24px radius"
      },
      "7x": {
        value: "28px",
        type: "borderRadius",
        description: "28px radius"
      },
      "8x": {
        value: "32px",
        type: "borderRadius",
        description: "32px radius"
      },
      "10x": {
        value: "40px",
        type: "borderRadius",
        description: "40px radius"
      },
      "15x": {
        value: "60px",
        type: "borderRadius",
        description: "60px radius"
      }
    },
    lineHeights: {
      xsmall: {
        value: "16px",
        type: "lineHeights"
      },
      small: {
        value: "20px",
        type: "lineHeights"
      },
      medium: {
        value: "24px",
        type: "lineHeights"
      },
      large: {
        value: "28px",
        type: "lineHeights"
      },
      xlarge: {
        value: "32px",
        type: "lineHeights"
      },
      xxlarge: {
        value: "40px",
        type: "lineHeights"
      },
      xxxlarge: {
        value: "48px",
        type: "lineHeights"
      }
    },
    fontFamilies: {
      fordF1: {
        value: "Ford F-1, sans-serif",
        type: "fontFamilies"
      },
      inter: {
        value: "Inter, sans-serif",
        type: "fontFamilies"
      }
    },
    fontWeights: {
      fordF1: {
        regular: "400",
        medium: "500",
        semiBold: "600"
      },
      inter: {
        regular: "400",
        medium: "500",
        semiBold: "600"
      }
    },
    fontSize: {
      xxxsmall: {
        value: "10px",
        type: "fontSizes"
      },
      xxsmall: {
        value: "12px",
        type: "fontSizes"
      },
      xsmall: {
        value: "14px",
        type: "fontSizes"
      },
      small: {
        value: "16px",
        type: "fontSizes"
      },
      medium: {
        value: "18px",
        type: "fontSizes"
      },
      large: {
        value: "20px",
        type: "fontSizes"
      },
      xlarge: {
        value: "22px",
        type: "fontSizes"
      },
      xxlarge: {
        value: "24px",
        type: "fontSizes"
      },
      xxxlarge: {
        value: "28px",
        type: "fontSizes"
      },
      xxxxlarge: {
        value: "32px",
        type: "fontSizes"
      },
      xxxxxlarge: {
        value: "40px",
        type: "fontSizes"
      }
    },
    borderWidth: {
      "1x": {
        value: "1px",
        type: "borderWidth",
        description: "1px width"
      },
      "2x": {
        value: "2px",
        type: "borderWidth",
        description: "2px width"
      },
      "4x": {
        value: "4px",
        type: "borderWidth",
        description: "4px width"
      },
      "8x": {
        value: "8px",
        type: "borderWidth",
        description: "8px width"
      }
    }
  }
}, i = {
  brandBlue: {
    100: o.primitive.color.fordBlue[100].value,
    // #e6e6ef
    200: o.primitive.color.fordBlue[200].value,
    // #cccede
    300: o.primitive.color.fordBlue[300].value,
    // #b3b5ce
    400: o.primitive.color.fordBlue[400].value,
    // #999dbd
    500: o.primitive.color.fordBlue[500].value,
    // #8084ad
    600: o.primitive.color.fordBlue[600].value,
    // #666b9d
    700: o.primitive.color.fordBlue[700].value,
    // #4d538c
    800: o.primitive.color.fordBlue[800].value,
    // #333a7c
    900: o.primitive.color.fordBlue[900].value,
    // #1a226b
    1e3: o.primitive.color.fordBlue[1e3].value,
    // #00095b
    1100: o.primitive.color.fordBlue[1100].value,
    // #000852
    1200: o.primitive.color.fordBlue[1200].value,
    // #000749
    1300: o.primitive.color.fordBlue[1200].value,
    // #000640
    1400: o.primitive.color.fordBlue[1200].value
    // #00052E
  },
  brandGrabber: {
    100: o.primitive.color.grabber[100].value,
    // #e8e6fe
    200: o.primitive.color.grabber[200].value,
    // #d1ccfd
    300: o.primitive.color.grabber[300].value,
    // #b9b3fc
    400: o.primitive.color.grabber[400].value,
    // #a299fb
    500: o.primitive.color.grabber[500].value,
    // #8b80fa
    600: o.primitive.color.grabber[600].value,
    // #7466f8
    700: o.primitive.color.grabber[700].value,
    // #5d4df7
    800: o.primitive.color.grabber[800].value,
    // #4533f6
    900: o.primitive.color.grabber[900].value,
    // #2e19f5
    1e3: o.primitive.color.grabber[1e3].value,
    // #1700f4
    1100: o.primitive.color.grabber[1100].value,
    // #1500dc
    1200: o.primitive.color.grabber[1200].value,
    // #1200c3
    1300: o.primitive.color.grabber[1200].value,
    // #1000AB
    1400: o.primitive.color.grabber[1200].value
    // #0C007A
  },
  brandTwilight: {
    0: o.primitive.color.twilight["000"].value,
    // #ffffff
    100: o.primitive.color.twilight[100].value,
    // #fafafb
    200: o.primitive.color.twilight[200].value,
    // #f5f6f7
    300: o.primitive.color.twilight[300].value,
    // #e6e8ea
    400: o.primitive.color.twilight[400].value,
    // #d1d5d9
    500: o.primitive.color.twilight[500].value,
    // #9ca3ad
    600: o.primitive.color.twilight[600].value,
    // #6b7786
    700: o.primitive.color.twilight[700].value,
    // #4d5b6d
    800: o.primitive.color.twilight[800].value,
    // #38485c
    900: o.primitive.color.twilight[900].value,
    // #1f3047
    1e3: o.primitive.color.twilight[1e3].value,
    // #00142e
    1100: o.primitive.color.twilight[1100].value,
    // #001025
    1200: o.primitive.color.twilight[1200].value,
    // #000000
    1300: o.primitive.color.twilight[1300].value,
    // #000E20
    1400: o.primitive.color.twilight[1400].value
    // #000A17
  },
  accentBlue: {
    100: o.primitive.color.skyview[100].value,
    // #e6f1fd
    200: o.primitive.color.skyview[200].value,
    // #cde2fc
    300: o.primitive.color.skyview[300].value,
    // #b4d4fa
    400: o.primitive.color.skyview[400].value,
    // #9bc5f9
    500: o.primitive.color.skyview[500].value,
    // #83b7f7
    600: o.primitive.color.skyview[600].value,
    // #6aa9f5
    700: o.primitive.color.skyview[700].value,
    // #519af4
    800: o.primitive.color.skyview[800].value,
    // #388cf2
    900: o.primitive.color.skyview[900].value,
    // #1f7df1
    1e3: o.primitive.color.skyview[1e3].value,
    // #066fef
    1100: o.primitive.color.skyview[1100].value,
    // #0564d7
    1200: o.primitive.color.skyview[1200].value,
    // #0559bf
    1300: o.primitive.color.skyview[1300].value,
    // #044EA7
    1400: o.primitive.color.skyview[1400].value
    // #033878
  },
  utilityDanger: {
    100: o.primitive.color.red[100].value,
    // #fbeae7
    200: o.primitive.color.red[200].value,
    // #f7d5ce
    300: o.primitive.color.red[300].value,
    // #f3c0b6
    400: o.primitive.color.red[400].value,
    // #efab9d
    500: o.primitive.color.red[500].value,
    // #eb9685
    600: o.primitive.color.red[600].value,
    // #e6816c
    700: o.primitive.color.red[700].value,
    // #e26c54
    800: o.primitive.color.red[800].value,
    // #de573b
    900: o.primitive.color.red[900].value,
    // #da4223
    1e3: o.primitive.color.red[1e3].value,
    // #d62d0a
    1100: o.primitive.color.red[1100].value,
    // #c12909
    1200: o.primitive.color.red[1200].value,
    // #ab2408
    1300: o.primitive.color.red[1300].value,
    // #962007
    1400: o.primitive.color.red[1400].value
    // #6B1705
  },
  utilitySuccess: {
    100: o.primitive.color.green[100].value,
    // #e6f3e6
    200: o.primitive.color.green[200].value,
    // #cce6cc
    300: o.primitive.color.green[300].value,
    // #b3dab3
    400: o.primitive.color.green[400].value,
    // #99cd99
    500: o.primitive.color.green[500].value,
    // #80c180
    600: o.primitive.color.green[600].value,
    // #66b466
    700: o.primitive.color.green[700].value,
    // #4da84d
    800: o.primitive.color.green[800].value,
    // #339b33
    900: o.primitive.color.green[900].value,
    // #198f19
    1e3: o.primitive.color.green[1e3].value,
    // #008200
    1100: o.primitive.color.green[1100].value,
    // #007500
    1200: o.primitive.color.green[1200].value,
    // #006800
    1300: o.primitive.color.green[1300].value,
    // #005B00
    1400: o.primitive.color.green[1400].value
    // #004100
  },
  utilityCaution: {
    100: o.primitive.color.amber[100].value,
    // #f8ede6
    200: o.primitive.color.amber[200].value,
    // #f1dccc
    300: o.primitive.color.amber[300].value,
    // #eacab3
    400: o.primitive.color.amber[400].value,
    // #e3b899
    500: o.primitive.color.amber[500].value,
    // #dda780
    600: o.primitive.color.amber[600].value,
    // #d69566
    700: o.primitive.color.amber[700].value,
    // #cf834d
    800: o.primitive.color.amber[800].value,
    // #c87133
    900: o.primitive.color.amber[900].value,
    // #c16019
    1e3: o.primitive.color.amber[1e3].value,
    // #ba4e00
    1100: o.primitive.color.amber[1100].value,
    // #a74600
    1200: o.primitive.color.amber[1200].value,
    // #953e00
    1300: o.primitive.color.amber[1300].value,
    // #823700
    1400: o.primitive.color.amber[1400].value
    // #5D2700
  }
}, H = i.brandBlue[1e3];
i.brandGrabber[1e3];
i.brandTwilight[1e3];
const a = {
  default: o.primitive.color.neutral[1e3].value,
  subtle: o.primitive.color.neutral[800].value,
  subtlest: o.primitive.color.neutral[700].value,
  placeholder: o.primitive.color.neutral[600].value,
  disabled: o.primitive.color.neutral[400].value,
  "onDisabled-subtle": o.primitive.color.neutral["000"].value,
  "onDisabled-strong": o.primitive.color.neutral[500].value,
  "primary-strong": o.primitive.color.skyview[1e3].value,
  "primary-strongest": o.primitive.color.skyview[1200].value,
  "secondary-strong": o.primitive.color.fordBlue[1e3].value,
  "tertiary-strong": o.primitive.color.grabber[1e3].value,
  danger: o.primitive.color.red[1e3].value,
  "danger-strongest": o.primitive.color.red[1200].value,
  caution: o.primitive.color.amber[1e3].value,
  "caution-strongest": o.primitive.color.amber[1200].value,
  success: o.primitive.color.green[1e3].value,
  "success-strongest": o.primitive.color.green[1200].value,
  onColor: o.primitive.color.neutral["000"].value
}, u = {
  default: o.primitive.color.neutral["000"].value,
  "neutral-subtlest": o.primitive.color.neutral[100].value,
  "neutral-subtle": o.primitive.color.neutral[300].value,
  "neutral-moderate": o.primitive.color.neutral[600].value,
  "neutral-strong": o.primitive.color.neutral[900].value,
  disabled: o.primitive.color.neutral[200].value,
  hover: o.primitive.color.neutral[200].value,
  "secondary-subtlest": o.primitive.color.fordBlue[100].value,
  "secondary-subtle": o.primitive.color.fordBlue[200].value,
  "secondary-strong": o.primitive.color.fordBlue[1e3].value,
  "tertiary-subtlest": o.primitive.color.grabber[100].value,
  "tertiary-subtle": o.primitive.color.grabber[200].value,
  "tertiary-strong": o.primitive.color.grabber[1e3].value,
  "primary-subtlest": o.primitive.color.skyview[100].value,
  "primary-subtle": o.primitive.color.skyview[200].value,
  "primary-strong": o.primitive.color.skyview[1e3].value,
  "danger-subtlest": o.primitive.color.red[100].value,
  "danger-subtle": o.primitive.color.red[200].value,
  "danger-strong": o.primitive.color.red[1e3].value,
  "caution-subtlest": o.primitive.color.amber[100].value,
  "caution-subtle": o.primitive.color.amber[200].value,
  "caution-strong": o.primitive.color.amber[1e3].value,
  "success-subtlest": o.primitive.color.green[100].value,
  "success-subtle": o.primitive.color.green[200].value,
  "success-strong": o.primitive.color.green[1e3].value,
  onColor: o.primitive.color.neutral["000"].value
}, w = {
  default: o.primitive.color.neutral[400].value,
  disabled: o.primitive.color.neutral[400].value,
  focus: o.primitive.color.skyview[1e3].value,
  "neutral-subtle": o.primitive.color.neutral[500].value,
  "neutral-moderate": o.primitive.color.neutral[600].value,
  "neutral-strong": o.primitive.color.neutral[1e3].value,
  "primary-subtle": o.primitive.color.skyview[200].value,
  "primary-strong": o.primitive.color.skyview[1e3].value,
  "primary-strongest": o.primitive.color.skyview[1200].value,
  danger: o.primitive.color.red[1e3].value,
  caution: o.primitive.color.amber[1e3].value,
  success: o.primitive.color.green[1e3].value,
  onColor: o.primitive.color.neutral["000"].value
}, n = {
  default: o.primitive.color.neutral[1e3].value,
  "neutral-strong": o.primitive.color.neutral[800].value,
  disabled: o.primitive.color.neutral[400].value,
  onDisabled: o.primitive.color.neutral["000"].value,
  primary: o.primitive.color.skyview[1e3].value,
  "primary-strongest": o.primitive.color.skyview[1200].value,
  "tertiary-strong": o.primitive.color.grabber[1e3].value,
  danger: o.primitive.color.red[1e3].value,
  "danger-strongest": o.primitive.color.red[1200].value,
  caution: o.primitive.color.amber[1e3].value,
  "caution-strongest": o.primitive.color.amber[1200].value,
  success: o.primitive.color.green[1e3].value,
  "success-strongest": o.primitive.color.green[1200].value,
  onColor: o.primitive.color.neutral["000"].value
}, s = {
  default: o.primitive.color.skyview[1e3].value,
  hover: o.primitive.color.skyview[1200].value,
  disabled: o.primitive.color.neutral[400].value,
  "hover-subtle": o.primitive.color.skyview[100].value,
  danger: o.primitive.color.red[1e3].value,
  "danger-hover": o.primitive.color.red[1200].value,
  "danger-hover-subtle": o.primitive.color.red[100].value,
  "neutral-moderate": o.primitive.color.neutral[600].value,
  "neutral-hover-subtle": o.primitive.color.neutral[200].value,
  onColor: o.primitive.color.neutral["000"].value
}, F = {
  surface: {
    inverted: {
      10: "#00142e1a",
      //  description: '10% opacity',
      20: "#00142e33",
      //  description: '20% opacity',
      30: "#00142e4d",
      //  description: '30% opacity',
      40: "#00142e66",
      //  description: '40% opacity',
      50: "#00142e80",
      //  description: '50% opacity',
      60: "#00142e99",
      //  description: '60% opacity',
      70: "#00142eB3",
      //  description: '70% opacity',
      80: "#00142eCC",
      //  description: '80% opacity',
      90: "#00142eE6",
      //  description: '90% opacity',
      100: o.primitive.color.neutral[1e3].value
      //  description: '100% opacity',
    },
    default: {
      10: "#FFFFFF1A",
      //  description: '10% opacity',
      20: "#FFFFFF33",
      //  description: '20% opacity',
      30: "#FFFFFF4d",
      //  description: '30% opacity',
      40: "#FFFFFF66",
      //  description: '40% opacity',
      50: "#FFFFFF80",
      //  description: '50% opacity',
      60: "#FFFFFF99",
      //  description: '60% opacity',
      70: "#FFFFFFB3",
      //  description: '70% opacity',
      80: "#FFFFFFCC",
      //  description: '80% opacity',
      90: "#FFFFFFE6",
      //  description: '90% opacity',
      100: o.primitive.color.neutral["000"].value
      //  description: '100% opacity',
    }
  },
  scrim: {
    white: {
      10: "#FFFFFF1A",
      //  description: 'Neutral.00 at 10% opacity',
      20: "#FFFFFF33",
      //  description: 'Neutral.00 at 20% opacity',
      30: "#FFFFFF4d",
      //  description: 'Neutral.00 at 30% opacity',
      40: "#FFFFFF66",
      //  description: 'Neutral.00 at 40% opacity',
      50: "#FFFFFF80",
      //  description: 'Neutral.00 at 50% opacity',
      60: "#FFFFFF99",
      //  description: 'Neutral.00 at 60% opacity',
      70: "#FFFFFFB3",
      //  description: 'Neutral.00 at 70% opacity',
      80: "#FFFFFFCC",
      //  description: 'Neutral.00 at 80% opacity',
      90: "#FFFFFFE6",
      //  description: 'Neutral.00 at 90% opacity',
      100: o.primitive.color.neutral["000"].value
      //  description: 'Neutral.00 at 100% opacity',
    },
    black: {
      10: "#00142e1a",
      // description: 'Neutral["1000"] at 10% opacity',
      20: "#00142e33",
      // description: 'Neutral["1000"] at 20% opacity',
      30: "#00142e4d",
      // description: 'Neutral["1000"] at 30% opacity',
      40: "#00142e66",
      // description: 'Neutral["1000"] at 40% opacity',
      50: "#00142e80",
      // description: 'Neutral["1000"] at 50% opacity',
      60: "#00142e99",
      // description: 'Neutral["1000"] at 60% opacity',
      70: "#00142eB3",
      // description: 'Neutral["1000"] at 70% opacity',
      80: "#00142eCC",
      // description: 'Neutral["1000"] at 80% opacity',
      90: "#00142eE6",
      // description: 'Neutral["1000"] at 90% opacity',
      100: o.primitive.color.neutral[1e3].value
      // description: 'Neutral["1000"] at 100% opacity',
    }
  }
}, S = {
  headline: '"Ford F-1", sans-serif',
  eyebrow: '"Inter", sans-serif',
  body: '"Inter", sans-serif'
}, ho = {
  fordF1: "Ford F-1, sans-serif",
  inter: "Inter, sans-serif"
}, P = {
  xxxsmall: "10px",
  xxsmall: "12px",
  xsmall: "14px",
  small: "16px",
  medium: "18px",
  large: "20px",
  xlarge: "22px",
  xxlarge: "24px",
  xxxlarge: "28px",
  xxxxlarge: "32px",
  xxxxxlarge: "40px"
}, B = {
  "0x": "0px",
  "1x": "4px",
  "2x": "8px",
  "3x": "12px",
  "4x": "16px",
  "5x": "20px",
  "6x": "24px",
  "7x": "28px",
  "8x": "32px",
  "10x": "40px"
}, W = {
  base: "0 4px 8px 0 rgba(0,0,0,0.06)",
  none: "none"
}, l = {
  px: "1px",
  "1x": "4px",
  // 0.25rem
  "2x": "8px",
  //0.5rem
  "3x": "12px",
  //0.75rem
  "4x": "16px",
  //1rem
  "5x": "20px",
  //1.25rem
  "6x": "24px",
  //1.5rem
  "7x": "28px",
  //1.75rem
  "8x": "32px",
  //2rem
  "9x": "36px",
  //2.25rem
  "10x": "40px",
  //2.5rem
  "11x": "44px",
  //2.75rem
  "12x": "48px",
  //3rem
  "13x": "52px",
  //3.25rem
  "14x": "56px",
  //3.5rem
  "15x": "60px",
  //3.75rem
  "16x": "64px",
  //4rem
  "18x": "72px",
  "20x": "80px",
  "22x": "88px",
  "25x": "100px",
  "28x": "112px",
  "32x": "128px"
  //8rem
}, g = {
  0: "0"
}, h = {
  0: "0",
  1: "-1"
}, m = {
  none: "none"
}, b = {
  none: "none"
}, C = {
  0: "0px"
}, D = "Inter, sans-serif", z = "Inter, sans-serif", c = {
  XXL: {
    fontFamily: o.primitive.fontFamilies.fordF1.value,
    fontWeight: o.primitive.fontWeights.fordF1.semiBold,
    lineHeight: o.primitive.lineHeights.xxxlarge.value,
    fontSize: o.primitive.fontSize.xxxxxlarge.value,
    letterSpacing: h[0],
    paragraphSpacing: g[0],
    paragraphIndent: C[0],
    textCase: m.none,
    textDecoration: b.none
  },
  XL: {
    fontFamily: o.primitive.fontFamilies.fordF1.value,
    fontWeight: o.primitive.fontWeights.fordF1.semiBold,
    lineHeight: o.primitive.lineHeights.xxlarge.value,
    fontSize: o.primitive.fontSize.xxxxlarge.value,
    letterSpacing: h[0],
    paragraphSpacing: g[0],
    paragraphIndent: C[0],
    textCase: m.none,
    textDecoration: b.none
  },
  L: {
    fontFamily: o.primitive.fontFamilies.fordF1.value,
    fontWeight: o.primitive.fontWeights.fordF1.semiBold,
    lineHeight: o.primitive.lineHeights.xlarge.value,
    fontSize: o.primitive.fontSize.xxlarge.value,
    letterSpacing: h[1],
    paragraphSpacing: g[0],
    paragraphIndent: C[0],
    textCase: m.none,
    textDecoration: b.none
  },
  M: {
    fontFamily: o.primitive.fontFamilies.fordF1.value,
    fontWeight: o.primitive.fontWeights.fordF1.semiBold,
    lineHeight: o.primitive.lineHeights.large.value,
    fontSize: o.primitive.fontSize.large.value,
    letterSpacing: h[0],
    paragraphSpacing: g[0],
    paragraphIndent: C[0],
    textCase: m.none,
    textDecoration: b.none
  },
  S: {
    fontFamily: o.primitive.fontFamilies.fordF1.value,
    fontWeight: o.primitive.fontWeights.fordF1.semiBold,
    lineHeight: o.primitive.lineHeights.medium.value,
    fontSize: o.primitive.fontSize.small.value,
    letterSpacing: h[0],
    paragraphSpacing: g[0],
    paragraphIndent: C[0],
    textCase: m.none,
    textDecoration: b.none
  },
  XS: {
    fontFamily: o.primitive.fontFamilies.fordF1.value,
    fontWeight: o.primitive.fontWeights.fordF1.semiBold,
    lineHeight: o.primitive.lineHeights.medium.value,
    fontSize: o.primitive.fontSize.xsmall.value,
    letterSpacing: h[0],
    paragraphSpacing: g[0],
    paragraphIndent: C[0],
    textCase: m.none,
    textDecoration: b.none
  }
}, p = {
  semiBold: {
    L: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.semiBold,
      lineHeight: o.primitive.lineHeights.large.value,
      fontSize: o.primitive.fontSize.medium.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    M: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.semiBold,
      lineHeight: o.primitive.lineHeights.medium.value,
      fontSize: o.primitive.fontSize.small.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    S: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.semiBold,
      lineHeight: o.primitive.lineHeights.small.value,
      fontSize: o.primitive.fontSize.xsmall.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    XS: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.semiBold,
      lineHeight: o.primitive.lineHeights.xsmall.value,
      fontSize: o.primitive.fontSize.xxsmall.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    }
  },
  medium: {
    L: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.medium,
      lineHeight: o.primitive.lineHeights.large.value,
      fontSize: o.primitive.fontSize.medium.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    M: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.medium,
      lineHeight: o.primitive.lineHeights.medium.value,
      fontSize: o.primitive.fontSize.small.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    S: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.medium,
      lineHeight: o.primitive.lineHeights.small.value,
      fontSize: o.primitive.fontSize.xsmall.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    XS: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.medium,
      lineHeight: o.primitive.lineHeights.xsmall.value,
      fontSize: o.primitive.fontSize.xxsmall.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    }
  },
  regular: {
    L: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.regular,
      lineHeight: o.primitive.lineHeights.large.value,
      fontSize: o.primitive.fontSize.medium.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    M: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.regular,
      lineHeight: o.primitive.lineHeights.medium.value,
      fontSize: o.primitive.fontSize.small.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    S: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.regular,
      lineHeight: o.primitive.lineHeights.small.value,
      fontSize: o.primitive.fontSize.xsmall.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    },
    XS: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.regular,
      lineHeight: o.primitive.lineHeights.xsmall.value,
      fontSize: o.primitive.fontSize.xxsmall.value,
      letterSpacing: h[0],
      paragraphSpacing: g[0],
      paragraphIndent: C[0],
      textCase: m.none,
      textDecoration: b.none
    }
  }
}, E = {
  "&--Expanded": { gap: o.primitive.space["10x"].value },
  "&--SuperCondensed": { gap: o.primitive.space["6x"].value },
  "&--Condensed": { gap: o.primitive.space["8x"].value },
  display: "flex",
  flexDirection: "column",
  width: "100%"
}, G = {
  display: "flex",
  flexDirection: "column",
  gap: o.primitive.space["2x"].value
}, V = {
  display: "flex",
  flexDirection: "column",
  gap: o.primitive.size["2x"].value,
  color: o.primitive.color.twilight[1e3].value,
  fontSize: o.primitive.fontSize.xxlarge.value,
  lineHeight: o.primitive.lineHeights.xlarge.value,
  fontFamily: S.headline,
  fontWeight: o.primitive.fontWeights.fordF1.medium
}, U = {
  display: "flex",
  color: o.primitive.color.twilight[700].value,
  fontSize: o.primitive.fontSize.xsmall.value,
  lineHeight: o.primitive.lineHeights.small.value,
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontWeight: o.primitive.fontWeights.inter.medium
}, j = {
  display: "flex",
  color: o.primitive.color.twilight[700].value,
  fontSize: o.primitive.fontSize.small.value,
  lineHeight: o.primitive.lineHeights.medium.value,
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontWeight: o.primitive.fontWeights.inter.medium
}, X = {
  display: "flex",
  color: o.primitive.color.twilight[700].value
}, Z = {
  display: "flex",
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontSize: o.primitive.fontSize.medium.value,
  lineHeight: o.primitive.lineHeights.large.value,
  fontWeight: o.primitive.fontWeights.inter.medium,
  color: o.primitive.color.twilight[1e3].value
}, Y = {
  display: "flex",
  flexDirection: "column",
  gap: o.primitive.size["2x"].value,
  svg: {
    color: o.primitive.color.twilight[800].value
  }
}, Q = {
  color: o.primitive.color.twilight[700].value,
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontSize: o.primitive.fontSize.xsmall.value,
  lineHeight: o.primitive.lineHeights.small.value,
  fontWeight: o.primitive.fontWeights.inter.medium
}, K = {
  display: "flex",
  alignItems: "center",
  gap: o.primitive.size.x1.value
}, N = {
  "&--Expanded": { rowGap: o.primitive.space["16x"].value },
  "&--SuperCondensed": { rowGap: o.primitive.space["5x"].value },
  "&--Condensed": { rowGap: o.primitive.space["10x"].value }
}, I = {
  MainWrapper: E,
  GridContent: N,
  HeaderSection: G,
  SectionTitle: V,
  Subtitle: U,
  Description: j,
  SecondaryLabel: X,
  ContentWrapper: Z,
  RowItemWrapper: Y,
  RowItemTitle: Q,
  RowTitleWrapper: K
}, y = {
  "1x": "1px",
  "2x": "2px",
  "4x": "4px",
  "8x": "8px"
}, _ = "392px", q = {
  width: _,
  border: `${y["1x"]} solid ${w.default}`,
  borderRadius: B["2x"],
  boxShadow: "0px 2px 8px 0px #0000001a",
  boxSizing: "border-box",
  position: "relative",
  padding: l["6x"],
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  "&--imageContainer": {
    gap: l["3x"]
  },
  "&--centerAligned": {
    alignItems: "center"
  },
  "&--leftAligned": {
    alignItems: "flex-start"
  },
  gap: l["6x"],
  "&--disabled": {
    cursor: "not-allowed",
    "&& > *": {
      color: `${w.disabled} !important`,
      "&::after": {
        borderRadius: B["2x"],
        content: '""',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.5)"
      }
    }
  },
  "&--selected": {
    backgroundColor: u["primary-subtle"],
    border: `${y["2x"]} solid ${w.focus}`
  },
  "&:not(&--disabled):hover": {
    cursor: "pointer",
    backgroundColor: u.hover
  },
  "&:not(&--disabled):focus-visible": {
    outline: `${y["2x"]} solid ${w.focus}`,
    outlineOffset: `${y["2x"]}`
  }
}, J = {
  color: a.default,
  fontFamily: c.L.fontFamily,
  fontWeight: c.L.fontWeight,
  fontSize: c.L.fontSize,
  lineHeight: c.L.lineHeight,
  "&--xlarge": {
    fontFamily: c.XL.fontFamily,
    fontWeight: c.XL.fontWeight,
    fontSize: c.XL.fontSize,
    lineHeight: c.XL.lineHeight
  }
}, ee = {
  margin: "unset !important",
  color: a.subtle,
  fontFamily: p.regular.S.fontFamily,
  fontWeight: p.regular.S.fontWeight,
  fontSize: p.regular.S.fontSize,
  lineHeight: p.regular.S.lineHeight
}, oe = {
  position: "relative",
  width: "100%",
  "&--withRadius": {
    borderRadius: `${B["2x"]} ${B["2x"]} 0 0`
  },
  "&--fixedContainer": {
    height: "96px",
    width: "96px"
  },
  overflow: "hidden"
}, ie = {
  width: "100%",
  boxSizing: "border-box",
  gap: l["3x"],
  display: "flex",
  flexDirection: "column",
  "&--centerAligned": {
    alignItems: "center",
    "h1,h2,h3,h4,h5,h6,p": {
      textAlign: "center"
    }
  },
  "&--leftAligned": {
    alignItems: "left",
    "h1,h2,h3,h4,h5,h6,p": {
      textAlign: "start"
    }
  },
  "&--disabled": {
    "&& > *": {
      color: w.disabled
    }
  }
}, re = {
  "&--xxLarge": {
    svg: {
      height: "72px ",
      width: "72px"
    }
  }
}, te = {
  width: "100%"
}, $ = {
  Wrapper: q,
  TitleContainer: J,
  DescriptionContainer: ee,
  MediaElementWrapper: oe,
  BodyWrapper: ie,
  IconContainer: re,
  TrailingElementWrapper: te
}, le = {
  display: "flex",
  flexDirection: "column",
  gap: l["2x"]
}, ae = {
  color: i.brandTwilight[1e3],
  fontFamily: p.regular.L.fontFamily,
  fontSize: p.regular.L.fontSize,
  fontWeight: p.regular.L.fontWeight,
  lineHeight: p.regular.L.lineHeight,
  textAlign: "center"
}, ne = {
  display: "flex",
  flexDirection: "column",
  gap: o.primitive.size["2x"].value,
  padding: "0 10px"
}, de = {
  display: "flex",
  flexDirection: "row",
  gap: l["2x"],
  justifyContent: "end",
  alignItems: "center"
}, ce = {
  "--animateTextFill": i.accentBlue[1100],
  "--animateTextDefault": i.brandTwilight[0]
}, se = {
  position: "relative",
  padding: l["1x"],
  color: i.accentBlue[1100],
  background: "transparent",
  border: "none",
  overflow: "hidden",
  fontSize: P.small,
  outline: "none",
  borderRadius: B["2x"],
  height: l["10x"],
  alignItems: "center",
  display: "flex",
  cursor: "unset",
  justifyContent: "center",
  "&.mobile": {
    width: "100%",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: i.accentBlue[100],
      color: i.accentBlue[1100]
    }
  },
  "&.animate": {
    animation: "textColorChange 5s ease-out forwards 3",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: "0%",
      width: "100%",
      height: "100%",
      backgroundColor: i.accentBlue[1e3],
      animation: "slide-in-out 5s ease forwards 3",
      zIndex: 0
    }
  },
  "& > .contact": {
    color: "inherit",
    position: "relative",
    zIndex: 1,
    fontFamily: p.medium.M.fontFamily,
    fontSize: p.medium.M.fontSize,
    fontWeight: p.medium.M.fontWeight,
    lineHeight: p.medium.M.lineHeight,
    textAlign: "left"
  },
  "&:focus-visible": {
    outline: `${y["2x"]} solid ${w.focus}`,
    outlineOffset: `${y["2x"]}`
  }
}, A = {
  CTAMobileWrapper: le,
  CTATitle: ae,
  CTAButtonWrapper: ne,
  CTADesktopWrapper: de,
  CTAButtonContact: se,
  CTAMainWrapper: ce
}, pe = {
  padding: "unset",
  margin: "unset",
  height: "auto",
  display: "flex",
  gap: l["6x"],
  flexDirection: "column",
  [`@media ${v.tabletAndUp}`]: {
    flexDirection: "row"
  }
}, ue = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: l["6x"],
  justifyContent: "center",
  [`@media ${v.tabletAndUp}`]: {
    width: "50%"
  }
}, ve = {
  position: "relative",
  width: "100%",
  [`@media ${v.tabletAndUp}`]: {
    width: "50%"
  }
}, ge = {
  display: "flex",
  flexWrap: "wrap",
  rowGap: l["6x"],
  columnGap: l["6x"],
  [`@media ${v.tabletAndUp}`]: {
    rowGap: l["16x"]
  }
}, he = {
  display: "flex",
  flexDirection: "column",
  gap: l["3x"]
}, me = {
  display: "flex",
  fontFamily: c.L.fontFamily,
  alignItems: "center",
  color: a.default,
  "&--extraLarge": {
    fontSize: c.XL.fontSize,
    lineHeight: c.XL.lineHeight,
    fontWeight: c.XL.fontWeight
  },
  "&--large": {
    fontSize: c.L.fontSize,
    lineHeight: c.L.lineHeight,
    fontWeight: c.L.fontWeight
  },
  "&--medium": {
    fontSize: c.M.fontSize,
    lineHeight: c.M.lineHeight,
    fontWeight: c.M.fontWeight
  }
}, be = {
  alignSelf: "stretch",
  color: a.subtle,
  fontStyle: "normal",
  fontFamily: p.semiBold.L.fontFamily,
  fontSize: p.semiBold.M.fontSize,
  fontWeight: p.semiBold.M.fontWeight,
  lineHeight: p.semiBold.M.lineHeight
}, Ce = {
  width: "100%",
  [`@media ${v.tabletAndUp}`]: {
    width: `calc(50% - ${l["3x"]})`
  }
}, xe = {
  display: "flex",
  flexDirection: "column",
  borderLeft: `1px solid ${w.default}`,
  paddingLeft: l["4x"]
}, fe = {
  color: a.default,
  fontStyle: "normal",
  fontWeight: c.XL.fontWeight,
  fontSize: c.XL.fontSize,
  lineHeight: c.XL.lineHeight,
  fontFamily: c.L.fontFamily
}, ye = {
  color: a.subtle,
  fontFamily: p.medium.L.fontFamily,
  fontSize: p.medium.L.fontSize,
  fontStyle: "normal",
  fontWeight: p.medium.L.fontWeight,
  lineHeight: p.medium.L.lineHeight
}, O = {
  MainWrapper: pe,
  MarketingListItemSection: ue,
  MarketingListItemWrapper: Ce,
  ImageWrapper: ve,
  ChildrenWrapper: ge,
  TitleSubTitleWrapper: he,
  TitleWrapper: me,
  SubTitleWrapper: be,
  ValueTextWrapper: xe,
  Value: fe,
  Text: ye
}, we = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "auto",
  minWidth: "280px",
  gap: o.primitive.space["6x"].value,
  [`@media ${v.tabletAndUp}`]: {
    "&--photoSplitShort, &--photoSplitLong, &--textSplit": {
      flexDirection: "row"
    },
    "&--textSplit": { gap: "84px" }
  },
  [`@media ${v.laptopAndUp}`]: {
    "&--textSplit": { gap: "92px" }
  },
  [`@media ${v.desktopAndUp}`]: {
    "&--textSplit": { gap: "116px" }
  },
  [`@media ${v.wideScreenAndUp}`]: {
    "&--textSplit": { gap: "140px" }
  }
}, ke = {
  display: "flex",
  flexDirection: "column",
  rowGap: o.primitive.space["6x"].value,
  width: "100%",
  height: "auto",
  borderRadius: o.primitive.radius["2x"].value,
  justifyContent: "flex-start",
  "&--textSplit": {
    justifyContent: "center"
  },
  [`@media ${v.tabletAndUp}`]: {
    "&--photoSplitShort, &--photoSplitLong": { width: "50%" }
  }
}, Te = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  width: "100%",
  gap: o.primitive.space["6x"].value,
  [`@media ${v.tabletAndUp}`]: {
    "&--photoSplitShort, &--photoSplitLong": { width: "50%" }
  }
}, Be = {
  display: "flex",
  flexDirection: "column",
  rowGap: o.primitive.space["3x"].value
}, Fe = {
  fontFamily: o.primitive.fontFamilies.fordF1.value,
  fontWeight: o.primitive.fontWeights.fordF1.semiBold,
  fontSize: o.primitive.fontSize.xxxxlarge.value,
  lineHeight: o.primitive.lineHeights.xxlarge.value,
  color: o.primitive.color.twilight[1e3].value,
  "&--large": {
    fontSize: o.primitive.fontSize.xxlarge.value,
    lineHeight: o.primitive.lineHeights.xlarge.value
  },
  "&--medium": {
    fontSize: o.primitive.fontSize.large.value,
    lineHeight: o.primitive.lineHeights.large.value
  }
}, Se = {
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontWeight: o.primitive.fontWeights.inter.semiBold,
  fontSize: o.primitive.fontSize.small.value,
  lineHeight: o.primitive.lineHeights.medium.value,
  color: o.primitive.color.twilight[800].value
}, De = {
  backgroundColor: o.primitive.color.twilight[400].value,
  width: "1px",
  height: "auto"
}, He = {
  display: "inline-flex",
  verticalAlign: "middle",
  marginRight: o.primitive.space["3x"].value,
  marginTop: "3px"
}, We = {
  fontFamily: o.primitive.fontFamilies.inter.value,
  "&--regular": {
    fontWeight: o.primitive.fontWeights.inter.regular,
    color: o.primitive.color.twilight[800].value
  },
  "&--medium": {
    fontWeight: o.primitive.fontWeights.inter.medium,
    color: o.primitive.color.twilight[1e3].value
  },
  fontSize: o.primitive.fontSize.medium.value,
  lineHeight: o.primitive.lineHeights.large.value,
  display: "flex"
}, ze = {
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  listStyleType: "none",
  rowGap: o.primitive.space["4x"].value,
  "&--default": { rowGap: o.primitive.space["1x"].value },
  width: "100%",
  [`@media ${v.tabletAndUp}`]: {
    "&--textStacked": { width: "calc(50% - 16.5px)" }
  },
  "&--dot": {
    "& > li:before": {
      content: '"•"',
      color: o.primitive.color.skyview[1e3].value,
      padding: "0 11px 0 8px"
    }
  },
  "&--dash": {
    "& > li:before": {
      content: '"-"',
      color: o.primitive.color.skyview[1e3].value,
      padding: "0 11px 0 8px"
    }
  }
}, Ie = {
  display: "flex",
  flexDirection: "column",
  "&--textStacked": { flexDirection: "row" },
  flexWrap: "wrap",
  columnGap: o.primitive.space["4x"].value,
  rowGap: o.primitive.space["4x"].value,
  [`@media ${v.tabletAndUp}`]: {
    "&--textStacked": { rowGap: o.primitive.space["12x"].value }
  }
}, $e = {
  height: "72px",
  width: "72px",
  "&--photoSplitShort,&--photoSplitLong": { height: "auto", width: "100%" },
  position: "relative",
  overflow: "hidden"
}, Ae = {
  "svg,img": {
    width: "72px",
    height: "72px"
  }
}, L = {
  Wrapper: we,
  ImageContainer: ke,
  ListContainer: Te,
  TitleWrapper: Fe,
  HeadingWrapper: Be,
  SubTitleWrapper: Se,
  VerticalDivider: De,
  MarketingListIconContainer: He,
  MarketingListItem: We,
  MarketingListGroupWrapper: ze,
  MarketingListGroupSetWrapper: Ie,
  MediaWrapper: $e,
  GraphicWrapper: Ae
}, Oe = {
  display: "flex",
  flexDirection: "column",
  gap: o.primitive.space["7x"].value
}, Le = {
  Wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: o.primitive.space["4x"].value,
    tabletView: { flexDirection: "row" }
  },
  Container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: o.primitive.space["4x"].value,
    tabletView: {
      justifyContent: "flex-start",
      width: "auto"
    }
  },
  ItemsPerPageDisplay: {
    fontSize: o.primitive.fontSize.small.value,
    fontWeight: o.primitive.fontWeights.inter.regular,
    lineHeight: o.primitive.lineHeights.medium.value,
    fontFamily: o.primitive.fontFamilies.inter.value,
    color: a.default
  }
}, Me = {
  Wrapper: {
    borderColor: "transparent",
    backgroundColor: "transparent",
    color: o.primitive.color.neutral[800].value
  }
}, Re = {
  Container: {
    width: "315px"
  }
}, Pe = {
  TableContainer: {
    borderRadius: o.primitive.radius["2x"].value,
    border: `${y["1x"]} solid var(--stroke-default, ${w.default})`,
    boxSizing: "border-box",
    width: "100%",
    overflowY: "auto",
    tabletView: {
      overflowX: "auto",
      position: "relative",
      justifyContent: "center",
      alignItems: "center"
    }
  },
  TableComponent: {
    background: `var(--color-fill-neutral-subtle, ${o.primitive.color.neutral[300].value}) !important`,
    display: "flex",
    height: "280px",
    flexDirection: "column",
    width: "100%",
    thead: {
      position: "sticky",
      zIndex: 1,
      top: 0
    },
    mobileView: {
      checkboxEnabled: {
        th: {
          display: "none"
        }
      },
      checkboxDisabled: {
        th: {
          display: "none"
        }
      }
    },
    tabletView: {
      display: "table",
      flexDirection: "unset",
      borderCollapse: "collapse",
      checkboxEnabled: {
        th: {
          display: "table-cell"
        }
      },
      checkboxDisabled: {
        th: {
          display: "table-cell"
        }
      }
    }
  }
}, Ee = {
  borderRadius: "inherit",
  div: {
    alignItems: "flex-start",
    width: "unset",
    borderTop: "unset",
    borderBottom: "unset",
    borderRadius: "unset",
    tabletView: { display: "none" }
  },
  borderTop: "unset",
  borderBottom: "unset"
}, Ge = {
  backgroundColor: {
    isBackground: `${o.primitive.color.twilight[100].value} !important`,
    none: `${o.primitive.color.twilight["000"].value} !important`
  },
  borderRadius: "inherit",
  padding: `${l["3x"]} ${l["4x"]}`,
  "&& > div": {
    paddingLeft: "unset"
  },
  '[data-component="accordion-dropdown-wrapper"]': {
    color: "unset"
  },
  '[data-component="accordion-title-wrapper"]': {
    height: "unset",
    fontFamily: o.primitive.fontFamilies.inter.value,
    fontSize: o.primitive.fontSize.small.value,
    fontStyle: "normal",
    fontWeight: o.primitive.fontWeights.inter.regular,
    lineHeight: o.primitive.lineHeights.medium.value
  }
}, Ve = {
  TableAccordionPanelContentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    gap: o.primitive.space["4x"].value,
    alignSelf: "stretch"
  },
  TableAccordionPanelContentData: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: o.primitive.space["2x"].value,
    div: {
      gap: o.primitive.space["3x"].value,
      alignItems: "center"
    },
    alignSelf: "stretch"
  }
}, Ue = {
  color: `var(--text-default, var(--primitive-color-neutral-1000, ${i.brandTwilight[1e3]}));`,
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontSize: o.primitive.fontSize.xsmall.value,
  fontStyle: "normal",
  fontWeight: o.primitive.fontWeights.inter.medium,
  lineHeight: o.primitive.lineHeights.small.value
}, je = {
  color: `var(--text-subtle, ${i.brandTwilight[800]});`,
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontSize: o.primitive.fontSize.small.value,
  fontStyle: "normal",
  fontWeight: o.primitive.fontWeights.inter.regular,
  lineHeight: o.primitive.lineHeights.medium.value
}, Xe = {
  width: "100%",
  height: "100%",
  justifyContent: "unset",
  margin: "unset",
  padding: `${o.primitive.space["2x"].value} ${o.primitive.space["4x"].value} ${o.primitive.space["4x"].value} ${o.primitive.space["6x"].value}`,
  "&& > div": {
    color: "unset",
    fontFamily: "unset",
    fontSize: "unset",
    letterSpacing: "unset",
    lineHeight: "unset"
  }
}, Ze = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  borderBottomRightRadius: o.primitive.radius["2x"].value,
  borderBottomLeftRadius: o.primitive.radius["2x"].value,
  "&& > div:nth-child(2n - 1)": {
    backgroundColor: `var(--fill-neutral-subtlest, ${o.primitive.color.twilight[100].value}) !important`
  },
  tabletView: {
    display: "table-row-group",
    isColumnButtonEnabled: {
      "&& > tr:last-child": {
        backgroundColor: "transparent !important",
        td: {
          paddingTop: o.primitive.space["6x"].value,
          height: "unset",
          paddingBottom: "unset"
        }
      }
    },
    "$isstickycolumn, $showcheckboxenabled": {
      td: {
        "nthChild: 2 &:before": {
          content: " ",
          position: "absolute",
          height: "100%",
          width: "10px",
          right: 0,
          top: 0,
          boxShadow: `${l["3x"]} 0px ${l["3x"]} 0px rgba(0, 0, 0, 0.12)`
        },
        firstChild: {
          position: "sticky",
          left: 0,
          backgroundColor: `var(--fill-neutral-subtlest, ${o.primitive.color.twilight["000"].value})`
        },
        "nthChild: 2": {
          left: "52px"
        }
      },
      "&& > tr:nth-child(2n)": {
        td: {
          firstChild: {
            backgroundColor: `var(--fill-neutral-subtlest, ${o.primitive.color.twilight[100].value}) !important`
          }
        }
      }
    },
    $isstickycolumn: {
      td: {
        firstChild: {
          position: "sticky",
          left: 0,
          backgroundColor: `var(--fill-neutral-subtlest, ${o.primitive.color.twilight["000"].value})`,
          "&:before": {
            content: " ",
            position: "absolute",
            height: "100%",
            width: "10px",
            right: 0,
            top: 0,
            boxShadow: `${l["3x"]} 0px ${l["3x"]} 0px rgba(0, 0, 0, 0.12)`
          }
        }
      },
      "&& > tr:nth-child(2n)": {
        td: {
          firstChild: {
            even: {
              backgroundColor: `var(--fill-neutral-subtlest, ${o.primitive.color.twilight[100].value}) !important`
            },
            odd: {
              backgroundColor: `var(--fill-neutral-subtlest, ${o.primitive.color.twilight["000"].value}) !important`
            }
          }
        }
      }
    }
  }
}, Ye = {
  [v.tabletAndUp]: {
    display: "table-cell",
    height: "56px",
    padding: `${l["1x"]} ${l["4x"]}`,
    "div:firstChild": {
      gap: `${l["3x"]}`,
      alignItems: { left: "flex-start", right: "flex-end", center: "center" }
    }
  }
}, Qe = {
  display: "flex",
  '[data-component="checkbox-wrapper"]': {
    label: {
      paddingBottom: "unset"
    }
  }
}, Ke = {
  alignSelf: "stretch",
  color: `var(--text-subtle, ${i.brandTwilight[800]})`,
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontSize: o.primitive.fontSize.xsmall.value,
  fontStyle: "normal",
  fontWeight: o.primitive.fontWeights.inter.regular,
  lineHeight: o.primitive.lineHeights.small.value,
  marketingTable: {
    fontFamily: o.primitive.fontFamilies.inter.value,
    fontSize: o.primitive.fontSize.xsmall.value,
    fontStyle: "normal",
    fontWeight: o.primitive.fontWeights.inter.regular,
    lineHeight: o.primitive.lineHeights.small.value
  }
}, Ne = {
  display: "flex",
  alignContent: "flex-start",
  justifyContent: "flex-start",
  alignItems: "center",
  color: `var(--semantic-color-text-subtle, ${i.brandTwilight[800]})`,
  label: {
    color: "inherit",
    fontWeight: o.primitive.fontWeights.inter.medium
  },
  marketingComparisonTable: {
    small: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.semiBold,
      lineHeight: o.primitive.lineHeights.medium.value,
      fontSize: o.primitive.fontSize.small.value,
      color: o.primitive.color.twilight[1e3].value
    },
    medium: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.semiBold,
      lineHeight: o.primitive.lineHeights.large.value,
      fontSize: o.primitive.fontSize.medium.value,
      color: o.primitive.color.twilight[1e3].value
    },
    large: {
      fontFamily: o.primitive.fontFamilies.inter.value,
      fontWeight: o.primitive.fontWeights.inter.semiBold,
      lineHeight: o.primitive.lineHeights.large.value,
      fontSize: o.primitive.fontSize.large.value,
      color: o.primitive.color.twilight[1e3].value
    },
    paddingLeft: o.primitive.space["3x"].value,
    paddingRight: o.primitive.space["3x"].value,
    buttonWrapper: {
      paddingLeft: o.primitive.space["3x"].value,
      paddingRight: o.primitive.space["3x"].value
    },
    padding: o.primitive.space["4x"].value,
    height: "100%"
  },
  tabletView: {
    fontFamily: o.primitive.fontFamilies.inter.value,
    fontSize: o.primitive.fontSize.small.value,
    fontStyle: "normal",
    fontWeight: o.primitive.fontWeights.inter.regular,
    lineHeight: o.primitive.lineHeights.medium.value
  },
  showAllContent: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical"
  }
}, _e = {
  height: l["8x"],
  verticalAlign: "bottom",
  paddingCheckbox: `${l["3x"]} ${l["4x"]} ${l["3x"]} 0px`,
  padding: `${l["3x"]} ${l["4x"]} ${l["3x"]} ${l["4x"]}`,
  alignItems: "center",
  div: {
    gap: `${l["4x"]}`,
    alignItems: "center",
    fontFamily: o.primitive.fontFamilies.inter.value,
    fontSize: o.primitive.fontSize.small.value,
    fontStyle: "normal",
    fontWeight: o.primitive.fontWeights.inter.medium,
    lineHeight: o.primitive.lineHeights.medium.value
  },
  textAlign: "left",
  backgroundColor: `var(--fill-neutral-subtlest, ${o.primitive.color.twilight[100].value}) !important`,
  tabletView: {
    height: l["12x"],
    padding: `0px ${l["4x"]}`,
    div: {
      ":first-child": {
        gap: "8px"
      },
      ":last-child": {
        marginBottom: o.primitive.space["6x"].value
      }
    }
  }
}, qe = {
  display: "flex",
  alignItems: "center",
  borderBottom: `${y["1x"]} solid var(--stroke-default, ${w.default})`,
  backgroundColor: `var(--fill-neutral-subtlest, ${o.primitive.color.twilight[100].value}) !important`,
  borderRadius: `${o.primitive.radius["2x"].value} ${o.primitive.radius["2x"].value} 0 0`,
  th: {
    div: {
      firstChild: {
        div: {
          firstChild: {
            display: "flex"
          }
        }
      }
    }
  },
  tabletView: {
    display: "table-header-group",
    flexDirection: "unset",
    th: {
      position: "sticky",
      zIndex: 1,
      top: 0
    },
    "$isstickycolumn $showcheckboxenabled": {
      th: {
        "nthChild: 2 &before:": {
          content: " ",
          position: "absolute",
          height: "100%",
          width: "10px",
          right: 0,
          top: 0,
          boxShadow: `${l["3x"]} 0px ${l["3x"]} 0px rgba(0, 0, 0, 0.12)`
        }
      },
      firstChild: {
        position: "sticky",
        left: 0,
        zIndex: 2
      },
      "nthChild: 2": {
        left: "52px"
      }
    },
    $isstickycolumn: {
      firstChild: {
        position: "sticky",
        left: 0,
        zIndex: 2,
        before: {
          content: " ",
          position: "absolute",
          height: "100%",
          width: "10px",
          right: 0,
          top: 0,
          boxShadow: `${l["3x"]} 0px ${l["3x"]} 0px rgba(0, 0, 0, 0.12)`
        }
      }
    }
  }
}, Je = {
  display: "none",
  borderRadius: "inherit",
  tabletView: {
    display: "table-row",
    "td:not(:first-child)": {
      "div:first-child:only-child": {
        color: `var(--text-subtle, ${i.brandTwilight[800]})`
      }
    }
  },
  width: "100%"
}, eo = {
  width: "100%",
  height: "200px",
  minHeight: "200px",
  backgroundColor: "inherit"
}, oo = {
  display: "flex",
  position: "absolute",
  width: `calc(100% - ${o.primitive.space["6x"].value})`,
  height: "200px",
  minHeight: "200px",
  padding: `var(--spacing-3x, ${o.primitive.space["3x"].value})`,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: `var(--spacing-2x, ${o.primitive.space["2x"].value})`,
  borderBottomRightRadius: o.primitive.space["2x"].value,
  borderBottomLeftRadius: o.primitive.space["2x"].value,
  color: `var(--color-text-default, ${o.primitive.color.neutral[1e3].value})`,
  textAlign: "center",
  background: `var(--color-fill-neutral-subtle, ${o.primitive.color.neutral[300].value}) !important`,
  fontFamily: `var(--font-family-body, ${o.primitive.fontFamilies.inter.value})`,
  fontSize: `var(--font-size-body-medium-S, ${o.primitive.fontSize.xsmall.value})`,
  fontStyle: "normal",
  fontWeight: `var(--font-weight-body-medium-S, ${o.primitive.fontWeights.inter.medium})`,
  lineHeight: `var(--line-height-body-medium-S, ${o.primitive.lineHeights.small.value})`,
  "&--marketingTable": {
    borderBottomLeftRadius: "unset",
    borderBottomRightRadius: "unset"
  },
  "&--mobile": {
    position: "unset",
    width: "unset",
    padding: "unset",
    height: "100%",
    minHeight: "unset"
  }
}, M = {
  TableContainer: Oe,
  TablePaginationView: Le,
  TableSortingView: Me,
  TableV1: Pe,
  TableAccordionData: Ee,
  TableAccordionItemData: Ge,
  TableAccordionPanelContent: Ve,
  TableAccordionPanelContentColumnData: Ue,
  TableAccordionPanelContentTableData: je,
  TableAccordionPanelData: Xe,
  TableBody: Ze,
  TableData: Ye,
  TableDataContentContainer: Qe,
  TableDataDescription: Ke,
  TableDataTextContainer: Ne,
  TableHeader: _e,
  TableRow: Je,
  TableSearchView: Re,
  TableHead: qe,
  TableEmptyViewContainer: eo,
  TableEmptyViewWrapper: oo
}, io = {
  color: o.primitive.color.twilight[1e3].value,
  "&--small": {
    fontFamily: o.primitive.fontFamilies.inter.value,
    fontWeight: o.primitive.fontWeights.inter.semiBold,
    lineHeight: o.primitive.lineHeights.medium.value,
    fontSize: o.primitive.fontSize.small.value
  },
  "&--medium": {
    fontFamily: o.primitive.fontFamilies.inter.value,
    fontWeight: o.primitive.fontWeights.inter.semiBold,
    lineHeight: o.primitive.lineHeights.large.value,
    fontSize: o.primitive.fontSize.medium.value
  },
  "&--large": {
    fontFamily: o.primitive.fontFamilies.inter.value,
    fontWeight: o.primitive.fontWeights.inter.semiBold,
    lineHeight: o.primitive.lineHeights.large.value,
    fontSize: o.primitive.fontSize.large.value
  }
}, ro = {
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontWeight: o.primitive.fontWeights.inter.regular,
  lineHeight: o.primitive.lineHeights.small.value,
  fontSize: o.primitive.fontSize.xsmall.value
}, to = {
  display: "flex",
  flexDirection: "column",
  gap: o.primitive.space["2x"].value,
  paddingLeft: o.primitive.space["3x"].value,
  paddingRight: o.primitive.space["3x"].value
}, lo = {
  paddingLeft: o.primitive.space["3x"].value,
  paddingRight: o.primitive.space["3x"].value,
  "&& > button": {
    width: "100%"
  }
}, ao = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  height: "100%",
  "&& > span:first-child": {
    position: "relative",
    "&::before": {
      content: '"  "',
      position: "absolute",
      height: "500%",
      width: "10px",
      right: 0,
      top: 0,
      boxShadow: `${y["1x"]} 0px ${y["1x"]} 0px ${o.primitive.color.twilight[400].value}`
    },
    "&::after": {
      content: " ",
      position: "absolute",
      height: "500%",
      width: "10px",
      right: 0,
      bottom: 0,
      boxShadow: `${y["1x"]} 0px ${y["1x"]} 0px ${o.primitive.color.twilight[400].value}`
    }
  }
}, no = {
  display: "flex",
  flexDirection: "column",
  gap: l["6x"]
}, co = {
  display: "flex",
  width: "80px",
  padding: o.primitive.space["4x"].value,
  color: o.primitive.color.twilight[1e3].value,
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontSize: o.primitive.fontSize.xsmall.value,
  lineHeight: o.primitive.lineHeights.small.value,
  fontWeight: o.primitive.fontWeights.inter.regular,
  "&--left": {
    textAlign: "left"
  },
  "&--right": {
    textAlign: "right"
  },
  "&--center": {
    textAlign: "center"
  },
  [`@media ${v.tabletAndUp}`]: {
    width: "unset",
    minWidth: "120px",
    display: "unset",
    padding: "unset"
  }
}, so = {
  display: "flex",
  width: "80px",
  justifyContent: "center",
  padding: o.primitive.space["4x"].value,
  svg: {
    color: o.primitive.color.twilight[1e3].value
  },
  [`@media ${v.tabletAndUp}`]: {
    width: "unset",
    display: "unset",
    justifyContent: "unset",
    padding: "unset"
  }
}, po = {
  display: "flex",
  width: "80px",
  justifyContent: "center",
  padding: o.primitive.space["4x"].value,
  svg: {
    color: o.primitive.color.twilight[400].value
  },
  [`@media ${v.tabletAndUp}`]: {
    width: "unset",
    display: "unset",
    justifyContent: "unset",
    padding: "unset"
  }
}, uo = {
  display: "flex",
  width: "80px",
  justifyContent: "center",
  padding: o.primitive.space["4x"].value,
  svg: {
    color: o.primitive.color.skyview[1200].value
  },
  [`@media ${v.tabletAndUp}`]: {
    width: "unset",
    display: "unset",
    justifyContent: "unset",
    padding: "unset"
  }
}, vo = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  color: o.primitive.color.twilight[1e3].value,
  fontFamily: o.primitive.fontFamilies.inter.value,
  fontSize: o.primitive.fontSize.xsmall.value,
  lineHeight: o.primitive.lineHeights.small.value,
  fontWeight: o.primitive.fontWeights.inter.regular,
  [`@media ${v.tabletAndUp}`]: {
    width: "unset",
    display: "unset",
    justifyContent: "unset"
  }
}, go = {
  overflow: "hidden",
  "&& > div:nth-child(even)": {
    backgroundColor: o.primitive.color.twilight[100].value
  },
  ["&& > span:nth-child(n)"]: {
    position: "relative",
    left: 0,
    "&::before": {
      content: '"  "',
      position: "absolute",
      height: "270%",
      width: "10px",
      right: "2px",
      bottom: 0,
      boxShadow: `${y["1x"]} 0px ${y["1x"]} 0px ${o.primitive.color.twilight[400].value}`
    }
  },
  ["&& > div:nth-child(n)"]: {
    position: "relative",
    left: 0,
    "&::before": {
      content: '"  "',
      position: "absolute",
      height: "270%",
      width: "10px",
      right: "2px",
      bottom: 0,
      boxShadow: `${y["1x"]} 0px ${y["1x"]} 0px ${o.primitive.color.twilight[400].value}`
    }
  }
}, R = {
  MarketingComparisonTableMobileViewHeader: io,
  MarketingComparisonTableMobileViewDescription: ro,
  MarketingComparisonTableMobileViewHeaderWrapper: to,
  MarketingComparisonTableMobileViewContentWrapper: go,
  MarketingComparisonTableMobileViewButtonWrapper: lo,
  MarketingComparisonTableValueWrapperMobileViewWrapper: ao,
  MarketingComparisonTableMobileViewContainer: no,
  TextWrapper: co,
  InformationWrapper: so,
  UncheckedWrapper: po,
  CheckedWrapper: uo,
  MarketingComparisonTableRowHeaderMobileView: vo
}, {
  accentBlue: r,
  brandBlue: x,
  brandGrabber: k,
  brandTwilight: e,
  utilityCaution: f,
  utilitySuccess: d,
  utilityDanger: t
} = i, mo = {
  typography: {
    primaryFont: D,
    secondaryFont: z
  },
  components: {
    marketingList: L,
    selectionCard: {
      FordProDefaultSelectionCard: $
    },
    readOnlySection: {
      FordProDefaultReadOnlySection: I
    },
    marketingDataList: O,
    ctaButton: {
      FordProDefaultCTAButton: A
    },
    disclosures: {
      disclosureTextColor: e[0]
    },
    PhotoGalleryLightbox: {
      closeButtonMobileColor: n.onColor,
      closeButtonTabletAndUpColor: n["neutral-strong"],
      navButtonBackgroundColor: s.default,
      navCaretColor: n.onColor,
      mainContainercolor: e[0],
      photoTitleColor: e[1e3],
      photoDescColor: e[1e3],
      closeButtonMobileHoverColor: e[1e3]
    },
    button: {
      focusRingColor: r[1e3],
      backgroundColorSolidDisabled: e[400],
      backgroundColorPrimarySolid: r[1e3],
      backgroundColorPrimarySolidHover: r[1200],
      backgroundColorPrimaryOutlineHover: r[100],
      backgroundColorPrimaryTextHover: r[100],
      backgroundColorDestructiveSolid: t[1e3],
      backgroundColorDestructiveSolidHover: t[1200],
      backgroundColorDestructiveOutlineHover: t[100],
      backgroundColorDestructiveTextHover: t[100],
      borderColorPrimaryOutline: r[1e3],
      borderColorPrimaryOutlineHover: r[1e3],
      borderColorDestructiveOutline: t[1e3],
      borderColorDestructiveOutlineHover: t[1e3],
      borderColorOutlineDisabled: e[400],
      textColorOutlineDisabled: e[400],
      textColorTextDisabled: e[400],
      textColorSolidDisabled: e[0],
      textColorPrimarySolid: e[0],
      textColorPrimaryOutline: r[1100],
      textColorPrimaryOutlineHover: r[1100],
      textColorPrimaryText: r[1100],
      textColorPrimaryTextHover: r[1100],
      textColorDestructiveSolid: e[0],
      textColorDestructiveOutline: t[1e3],
      textColorDestructiveOutlineHover: t[1e3],
      textColorDestructiveText: t[1e3],
      textColorDestructiveTextHover: t[1e3],
      default: {
        default: {
          disabled: {
            outlineColor: "transparent",
            textColor: a["onDisabled-subtle"],
            backgroundColor: s.disabled
          }
        },
        text: {
          disabled: {
            outlineColor: "transparent",
            textColor: a.disabled,
            backgroundColor: "transparent"
          }
        },
        secondary: {
          disabled: {
            outlineColor: s.disabled,
            textColor: a.disabled,
            backgroundColor: "transparent"
          }
        }
      },
      onColor: {
        default: {
          textColor: a.default,
          backgroundColor: s.onColor,
          hover: {
            backgroundColor: u["neutral-subtle"]
          },
          disabled: {
            outlineColor: "transparent",
            backgroundColor: s["neutral-moderate"],
            textColor: a["onDisabled-strong"]
          }
        },
        text: {
          textColor: a.onColor,
          hover: {
            textColor: a.onColor,
            backgroundColor: s["neutral-moderate"]
          },
          disabled: {
            outlineColor: "transparent",
            backgroundColor: "transparent",
            textColor: a.placeholder
          }
        },
        secondary: {
          borderOutlineColor: s.onColor,
          textColor: a.onColor,
          hover: {
            backgroundColor: "var(--semantic-color-opacity-surface-inverted-20, #FFFFFF33)",
            borderOutlineColor: s.onColor,
            textColor: a.onColor
          },
          disabled: {
            outlineColor: s["neutral-moderate"],
            backgroundColor: "transparent",
            textColor: a.placeholder
          }
        },
        focusRing: s.onColor
      }
    },
    chart: {
      mode: "light"
    },
    iconButton: {
      textColorGhostBlack: e[1e3],
      backgroundColorGhostBlack: "transparent",
      backgroundColorGhostBlackHover: e[200],
      colorSuccess: d[1e3],
      primaryTextColor: r[1e3],
      hoverColorSuccess: d[1200],
      secondaryHoverColorSuccess: d[100],
      colorDanger: t[1e3],
      hoverColorDanger: t[1200],
      secondaryHoverColorDanger: t[100],
      colorOnColor: e[800],
      bgColorOnColor: e[0],
      textColor: e[0],
      bgColor: e[0],
      tertiaryColorOnColor: e[0],
      bgTertiaryColorOnColor: e[600],
      bgSecHoverColorOnColor: e[600],
      bgDisabledColorOnColor: e[600],
      disabledColorOnColor: e[400],
      hoverColorOnColor: e[300],
      secondaryHoverColorOnColor: F.surface.default[20],
      secondaryColorOnColor: e[0]
    },
    filters: {
      borderColor: e[400],
      disabledColor: e[500],
      disabledBackground: e[200],
      hoverBackground: e[200],
      defaultColor: e[800],
      activeColor: r[1e3],
      activeBorderColor: r[1e3],
      activeBackground: r[100],
      defaultBackground: e[0]
    },
    tabs: {
      textDefaultColor: e[700],
      textHoverColor: k[1e3],
      textActiveColor: e[1e3],
      textDisabledColor: e[400],
      tabBottomBorder: e[400],
      tabHoverBottomBorder: e[500],
      tabActiveBottomBorder: r[1e3],
      tabFocusRing: r[1e3],
      tabHeaderBorderBottom: e[300]
    },
    list: {
      textColor: e[800],
      orderedButllerColor: e[1e3],
      listBulletColor: r[1e3],
      listLinkColor: r[1e3]
    },
    segmentControl: {
      borderColor: e[500],
      backgroundColor: r[100],
      focusColor: r[1e3],
      textColor: e[1e3],
      iconColor: r[1200],
      activeBackgroundColor: r[1e3],
      hoverColor: e[200],
      activeTextColor: e[0],
      disabledBackgroundColor: e[400]
    },
    datePicker: {
      backgroundColorCalendar: e[0],
      backgroundColorMonthYear: r[200],
      backgroundDayDisabled: e[400],
      borderColorCalendar: e[400],
      borderColorDayHover: r[1e3],
      borderColorMonthYearHover: r[1e3],
      fillDaySelected: r[1e3],
      fillMonthArrow: r[1e3].substring(1),
      fillMonthYearClose: e[1e3].substring(1),
      textColorMonthYear: r[1e3],
      textColorDay: e[1e3],
      textColorDayDisabled: e[500],
      textColorDaySelected: e[0],
      textColorDayWeekend: e[600],
      textColorWeekdays: e[600],
      placeHolderColor: e[600],
      placeHolderDisabledColor: e[500],
      iconColor: i.brandTwilight[800],
      iconDisabledColor: i.brandTwilight[400],
      closeIconHoverBackground: s["neutral-hover-subtle"],
      caretIconHoverBackground: s["hover-subtle"]
    },
    select: {
      backgroundColor: e[0],
      borderColorDefault: e[300],
      labelColor: e[1e3]
    },
    drawer: {
      backgroundColor: e[0],
      borderColorDefault: e[400],
      titleColor: e[1e3],
      bodyColor: e[1e3],
      subtitleColor: e[700],
      closeButtonColor: x[800]
    },
    phoneInput: {
      backgroundColor: e[0],
      backgroundColorDisabled: e[200],
      borderColorDefault: e[400],
      textColorCountryCode: e[1e3],
      labelColor: e[1e3],
      outlineColorFocusHover: r[1e3],
      backgroundColorOnHover: e[200],
      disableTextColor: "#545454",
      arrowBorderColor: e[1e3]
    },
    textArea: {
      backgroundColor: e[0],
      backgroundColorDisabled: e[300],
      borderColorDefault: e[400],
      borderColorDisabled: "transparent",
      borderColorFilled: e[400],
      labelColor: e[1e3],
      outlineColorFocusHover: r[1e3],
      textColorDisabled: e[600],
      textColorPlaceholder: e[600],
      textColorFilled: e[1e3],
      optionalTextColor: e[700]
    },
    textInput: {
      default: {
        defaultBorder: e[400],
        focusBorder: r[1e3],
        background: e[0],
        helper: a.subtle
      },
      disable: {
        defaultBorder: e[400],
        background: e[200],
        helper: e[600]
      },
      error: {
        defaultBorder: t[1e3],
        focusBorder: t[1e3],
        background: e[0],
        helper: t[1e3]
      },
      caution: {
        defaultBorder: "#B16201",
        focusBorder: "#B16201",
        background: e[0],
        helper: "#854901"
      },
      textColorDisabled: e[500],
      textColorPlaceholder: e[600],
      textColorFilled: e[1e3]
    },
    selectInput: {
      focusBorder: r[1e3],
      background: e[0],
      iconColor: e[800]
    },
    tooltip: {
      backgroundColor: e[0],
      borderColor: x[1e3],
      textColor: e[800],
      boxShadow: W.base
    },
    inLineAlert: {
      neutralBackground: e[300],
      informationBackground: r[100],
      errorBackground: t[100],
      warningBackground: f[100],
      successBackground: d[100],
      neutralHoverBackground: e[400],
      informationHoverBackground: r[200],
      errorHoverBackground: t[200],
      warningHoverBackground: f[200],
      successHoverBackground: d[200],
      neutralFontColor: e[1e3],
      informationFontColor: r[1200],
      errorFontColor: t[1200],
      warningFontColor: f[1200],
      successFontColor: d[1200]
    },
    spinner: {
      circleBorderColor: r[100],
      circleProgressBarBorderColor: r[1e3]
    },
    menu: {
      textColor: e[800],
      backgroundColor: e[0],
      textColorDisabled: e[600],
      listItemHoverColor: e[200],
      listItemBackgroundColor: e[0],
      borderColor: e[400],
      groupTitleColor: e[1e3],
      dividerColor: "#D1D5DB",
      focusColor: k[1e3],
      ellipsesBackgroundColor: e[200],
      ellipsesColor: x[1e3],
      focusRingColor: r[1200]
    },
    dropdownMenu: {
      textColor: e[1e3],
      backgroundColor: e[0],
      textColorDisabled: e[400],
      listItemHoverColor: e[200],
      listItemBackgroundColor: e[0],
      borderColor: e[400],
      contentColor: e[800],
      groupTitleColor: e[1e3],
      dividerColor: "#D1D5DB",
      focusColor: r[1e3],
      selectedItemBackground: r[100],
      selectedItemColor: r[1200],
      scrollbar: {
        corner: e[1200],
        thumb: e[500],
        track: e[300]
      },
      check: e[500]
    },
    dataList: {
      contentColor: e[1e3],
      secondaryContentColor: e[700],
      defaultBgColor: e[0],
      hoverBgColor: e[200],
      activeBgColor: e[300],
      trailingColor: r[1e3],
      staticBgColor: "transparent",
      borderColor: e[400],
      focusRingColor: r[1e3],
      neutralColor: e[800]
    },
    modalWindow: {
      closeButtonColor: x[800],
      modalWindowColor: e[1e3],
      modalWindowBackground: e[0],
      modalWindowBackgroundOverlay: e[1e3]
    },
    addressInput: {
      backgroundColor: e[0],
      borderColor: e[400],
      color: e[1e3],
      backgroundColorOnHover: e[200]
    },
    search: {
      color: e[800],
      iconColor: e[400],
      subTextColor: e[600],
      subTextErrorColor: t[1e3],
      dividerColor: e[400],
      contentColor: e[800]
    },
    searchInputLocation: {
      subTextColor: e[600],
      subTextErrorColor: t[1e3],
      iconColor: e[800]
    },
    checkbox: {
      fontColor: a.default,
      focusColor: i.accentBlue[1e3],
      errorFocusColor: i.utilityDanger[1e3],
      errorFontColor: i.utilityDanger[1e3],
      disabledFontColor: i.brandTwilight[600],
      inactiveOutlineColor: w["neutral-subtle"],
      inactiveOutlineHoverColor: i.accentBlue[1e3],
      inactiveBackgroundColor: i.brandTwilight[0],
      activeHoverOutlineColor: i.accentBlue[1e3],
      activeBackgroundColor: i.accentBlue[1e3],
      activeHoverBackgroundColor: i.accentBlue[1200],
      inactiveErrorOutlineColor: i.utilityDanger[1e3],
      activeErrorOutlineColor: i.utilityDanger[1e3],
      activeErrorBackgroundColor: i.utilityDanger[1e3],
      activeHoverErrorBackgroundColor: i.utilityDanger[1200],
      disabledOutlineColor: i.brandTwilight[400],
      inactiveDisabledBackgroundColor: i.brandTwilight[200],
      activeDisabledBackgroundColor: i.brandTwilight[400],
      disabledClickColor: "rgba(214, 45, 10, 0.5)",
      checkmarkColor: i.brandTwilight[0],
      checkmarkErrorColor: i.brandTwilight[0],
      checkmarkDisabledColor: i.brandTwilight[200],
      checkmarkDisabledActive: i.brandTwilight[300]
    },
    radio: {
      textColor: e[1e3],
      backgroundColor: e[0],
      borderColor: e[600],
      hoverColor: r[1e3],
      activeColor: r[1e3],
      errorColor: t[1e3],
      textColorDisabled: e[600],
      borderColorDisabled: e[400],
      backgroundColorDisabled: e[200],
      fillColor: r[1e3],
      hoverActiveColor: r[1200],
      errorHoverColor: t[1200],
      checkedBackgroundColor: e[0],
      focusColor: r[1e3],
      errorTextColor: t[1e3],
      disabledClickColor: "rgba(214, 45, 10, 0.5)",
      disabledClickBackgroundColor: e[300]
    },
    accordion: {
      borderBottom: e[400],
      backgroundColor: e[0],
      boxDisabledBackgroundColor: e[200],
      hoverBorderBottom: r[1e3],
      boxBorderColor: e[400],
      boxHoverOutlineColor: r[1e3],
      titleColor: e[1e3],
      textDisabledColor: e[500],
      subTitleColor: e[800],
      iconColor: e[1e3],
      iconDisabledColor: e[400],
      toggleIconColor: r[1e3]
    },
    incrementSelector: {
      textColor: e[1e3],
      textColorDisabled: e[400],
      textColorHelperText: e[800],
      textColorLabel: e[1e3],
      textInputOutlineColor: r[1e3],
      iconFocusRingColor: r[1e3],
      border: e[400],
      defaultBackgroundColor: e[0],
      iconHoverBackgroundColor: s["neutral-hover-subtle"],
      invalidErrorOutlineColor: i.utilityDanger[1e3]
    },
    popover: {
      titleColor: e[1e3],
      backgroundColor: e[0],
      textColor: e[800],
      linkColor: k[1e3],
      linkDividerColor: e[600],
      closeButtonColor: x[1e3],
      dividerColor: x[200],
      borderColor: e[1e3]
    },
    link: {
      onImageTextColor: e[0],
      onImageHoverColor: e[0],
      onImageVisitedColor: e[0],
      textColor: r[1100],
      hoverColor: r[1300],
      activeColor: x[800],
      visitedColor: x[800],
      disabledColor: e[500],
      borderColor: "#066FEF"
    },
    inLineText: {
      iconColor: i.accentBlue[1e3],
      fontColor: i.brandTwilight[1e3],
      focusRingColor: i.accentBlue[1e3],
      activeRingColor: i.accentBlue[1e3],
      inactiveRingColor: i.brandTwilight[400],
      errorRingColor: i.utilityDanger[1e3],
      errorTextColor: i.utilityDanger[1e3],
      hoverBackgroundColor: i.brandTwilight[200],
      disabledFontColor: i.brandTwilight[400],
      disabledIconColor: i.brandTwilight[400],
      openBackgroundColor: i.brandTwilight[0]
    },
    skeleton: {
      gradientColor0: e[100],
      gradientColor1: e[300],
      gradientColor2: e[200]
    },
    card: {
      titleColor: i.brandTwilight[1e3],
      contentColor: i.brandTwilight[800],
      cardBackground: i.brandTwilight[0],
      ghostTitleColor: i.brandTwilight[1e3],
      ghostContentColor: i.brandTwilight[800],
      borderColor: i.brandTwilight[400],
      gradientOverlayStartColor: "rgba(0, 20, 46, 0)",
      gradientOverlayEndColor: "rgba(0, 20, 46, 0.5)"
    },
    textDisclosure: {
      titleColor: i.brandTwilight[800],
      contentColor: i.brandTwilight[700],
      linkHoverColor: i.accentBlue[1300]
    },
    progressTracker: {
      activeColor: i.accentBlue[1e3],
      errorColor: i.utilityDanger[1e3],
      defaultColor: i.brandTwilight[600],
      defaultLabelColor: i.brandTwilight[700],
      activeBgColor: i.brandTwilight[0],
      labelColor: i.brandTwilight[1e3]
    },
    pageHeader: {
      primaryFont: "Ford F-1, sans-serif",
      titleColor: e[1e3],
      subTitleColor: a.subtle,
      descriptionColor: e[700]
    },
    featureText: {
      primaryFont: "Ford F-1, sans-serif",
      secondaryFont: "Inter",
      titleColor: e[1e3],
      descriptionColor: e[800]
    },
    heroVideo: {
      textColor: e[0],
      videoBackground: e[1e3]
    },
    landingHeroVideo: {
      textColor: e[0],
      videoBackground: e[1e3]
    },
    blogVideo: {
      videoPlaceholderBackgroundColor: "#000",
      subheadlineTextColor: e[1e3],
      headlineTextColor: e[1e3],
      bodyTextColor: e[800],
      gradientOverlayStartColor: "rgba(0, 20, 46, 0)",
      gradientOverlayEndColor: "rgba(0, 20, 46, 0.65)"
    },
    landingPageVideo: {
      videoPlaceholderBackgroundColor: "#000",
      miniTitleTextColor: e[1e3],
      titleTextColor: e[1e3],
      bodyTextColor: e[800],
      gradientOverlayStartColor: "rgba(0, 20, 46, 0)",
      gradientOverlayEndColor: "rgba(0, 20, 46, 0.65)"
    },
    progressBar: {
      textColor: e[1e3],
      helperTextColor: e[800],
      errorTextColor: t[1e3],
      defaultProgressBarColor: r[1e3],
      backgroundColor: e[300],
      successProgressBarColor: d[1e3]
    },
    videoPlayer: {
      videoControlsColor: e[0],
      videoControlsBackgroundColor: "rgba(0, 20, 46, 0.7)",
      videoDurationTextColor: e[0],
      volumeBarColor: e[0],
      volumeBarThumbColor: e[0],
      focusColor: r[1e3],
      progressBarViewedColor: r[1e3],
      progressBarDefaultColor: "rgba(255, 255, 255, 0.4)",
      progressBarLoadedColor: "rgba(255, 255, 255, 0.5)",
      captionsEnabledColor: r[1e3],
      buttonHoverColor: "rgba(255, 255, 255, 0.1)",
      buttonDisabledColor: "rgba(255, 255, 255, 0.4)"
    },
    cookieBanner: {
      cookieBannerColor: e[1e3],
      cookieBannerBackground: e[0]
    },
    slider: {
      backgroundColor: e[0],
      borderColor: r[1e3],
      thumbHoverBackgroundColor: r[100],
      thumbActiveBackgroundColor: r[1e3],
      sliderTrackBackgroundColor: e[500],
      sliderRangeBackgroundColor: r[1e3],
      sliderTickColor: e[500],
      textColorFilled: e[800],
      labelTextColor: e[1e3],
      textColorDisabled: e[1e3],
      disableTextColor: e[500],
      borderColorDisabled: e[400],
      inputBorderColor: e[400],
      disabledBackgroundColor: e[400],
      disabledInputBackgroundColor: e[200],
      disableLabelTextColor: e[400],
      focusColor: r[1e3]
    },
    fileUpload: {
      defaultDropzoneBorderColor: i.brandTwilight[500],
      dropZoneBorderColor: i.accentBlue[1200],
      dropZonehoverBgColor: i.accentBlue[100],
      labelColor: i.brandTwilight[1e3],
      helperTextColor: i.brandTwilight[700],
      progressBarBorderColor: i.brandTwilight[400],
      dropZoneContentColor: i.brandTwilight[800],
      dropZoneLinkColor: i.accentBlue[1e3],
      progressBarIconColor: i.brandTwilight[1e3],
      dropZoneDisableColor: i.brandTwilight[400]
    },
    showMoreLess: {
      labelTextHoverColor: r[1200],
      labelBorderColor: r[1200],
      labelTextColor: r[1e3],
      labelTextDisabledColor: o.primitive.color.twilight[400].value,
      svgDisabledColor: o.primitive.color.twilight[400].value,
      focusRingColor: r[1200]
    },
    raisedSurface: {
      borderColor: e[400],
      backgroundColor: e[0]
    },
    globalAttributeBar: {
      titleTextColor: e[800],
      valueTextColor: e[1e3],
      descriptionTextColor: e[800],
      backgroundColor: e[0],
      borderColor: e[400]
    },
    pagination: {
      mobileViewTextColor: e[700],
      navButtonColor: r[1e3],
      navDisabledColor: e[400],
      outlineColor: r[1e3],
      listHoverColor: r[100],
      pageLinkBackgroundColor: r[1e3],
      dotsColor: e[700]
    },
    creditCardInput: {
      placeholderColor: a.placeholder,
      placeholderDisabledColor: a["onDisabled-strong"]
    },
    chip: {
      labelColor: e[1e3],
      buttonColor: r[1100],
      focusRing: r[1e3]
    },
    closeButton: {
      light: {
        backgroundColor: {
          default: s["neutral-hover-subtle"],
          accent: u["primary-subtlest"],
          green: u["success-subtlest"],
          orange: u["caution-subtlest"],
          red: u["danger-subtlest"]
        },
        iconColor: {
          default: n.default,
          accent: n.primary,
          green: n.success,
          orange: n.caution,
          red: n.danger,
          hoverAccent: n["primary-strongest"],
          hoverGreen: n["success-strongest"],
          hoverOrange: n["caution-strongest"],
          hoverRed: n["danger-strongest"]
        }
      },
      dark: {
        backgroundColor: {
          default: F.scrim.white[20],
          accent: r[1e3],
          green: d[1e3],
          orange: f[1e3],
          red: t[1e3]
        },
        iconColor: {
          default: e[0],
          accent: r[500],
          green: d[500],
          orange: f[500],
          red: t[500]
        }
      }
    },
    modalVideo: {
      closeIconColor: n.onColor
    },
    tag: {
      backgroundColor: {
        hoverDefault: s["neutral-hover-subtle"],
        hoverAccent: u["primary-subtle"],
        hoverSuccess: u["success-subtle"],
        hoverCaution: u["caution-subtle"],
        hoverDanger: u["danger-subtle"]
      }
    },
    label: {
      labelColor: a.default,
      optionalTextColor: a.subtlest,
      infoIconColor: e[800]
    },
    dataTable: M,
    marketingComparisonTable: R
  },
  colors: {
    pageBackgroundColor: e[0],
    primaryColor: x[1e3],
    primaryHoverColor: x[700],
    primaryActiveColor: x[100],
    formElementBackground: e[100],
    textOnFormElementBackground: e[600],
    textColorOnPrimary: e[100],
    textColor: e[600],
    textColorInverted: e[100],
    disabled: e[400],
    iconDefaultColor: e[600],
    status: {
      warningColor: f[100],
      warningColorHover: f[200],
      warningColorActive: f[300],
      errorColor: t[100],
      errorColorHover: t[200],
      errorColorActive: t[300],
      errorHoverColor: t[1e3],
      successColor: d[100],
      successColorHover: d[200],
      successColorActive: d[300]
    }
  }
};
e[600], n.onColor, n["neutral-strong"], s.default, n.onColor, e[0], e[1e3], e[1e3], e[1e3], r[1e3], e[900], r[1e3], r[1200], t[1e3], t[1200], r[500], r[800], t[800], t[1e3], e[800], e[800], e[800], e[500], e[0], r[500], r[800], r[500], r[800], e[0], t[800], t[1e3], t[800], t[1e3], t[100], t[100], t[100], t[1e3], e[0], e[0], e[1e3], e[200], d[1e3], r[1e3], d[1200], d[100], t[1e3], t[1200], t[100], e[800], e[0], e[0], e[0], e[0], e[600], e[600], e[600], e[400], e[300], F.surface.default[20], e[0], e[300], r[100], t[100], f[100], d[100], e[400], r[200], t[200], f[200], d[200], e[1e3], r[1200], t[1200], f[1200], d[1200], e[400], e[500], e[200], e[200], e[800], r[1e3], r[1e3], r[100], e[0], e[400], e[0], e[0], e[500], e[0], e[0], e[0], e[0], e[800], e[200], e[0], e[0], r[1e3], r[1200], r[100], r[1e3], r[1200], r[1200], r[200], e[900], `${e[0]}`, `${e[300]}`, e[800], e[0], e[0], e[0], e[400].substring(1), e[0].substring(1), e[0], e[0], e[600], r[1e3], e[600], e[400], e[400], e[500], i.brandTwilight[100], i.brandTwilight[800], s["neutral-hover-subtle"], s["hover-subtle"], e[900], e[800], e[0], e[900], e[800], e[0], e[400], e[0], e[900], e[1200], e[400], e[400], e[400], e[1200], e[400], e[900], e[800], e[0], e[400], e[1e3], e[400], e[0], e[400], e[400], e[900], e[400], e[800], e[400], t[1e3], t[1e3], e[900], t[1e3], e[900], e[1e3], e[400], e[0], e[400], e[900], e[300], e[0], x[1e3], e[800], W.base, e[700], e[400], e[200], e[400], e[1e3], e[900], e[1e3], e[800], e[200], e[800], e[0], e[900], e[0], r[1200], e[200], e[700], e[1e3], e[900], e[1e3], e[800], e[200], e[500], e[800], e[0], r[100], r[1200], e[1200], e[500], e[300], e[500], e[1e3], e[700], e[0], e[200], e[300], r[1e3], e[400], r[1e3], e[800], e[0], e[0], e[900], e[1e3], e[900], e[800], e[0], e[800], i.brandTwilight[200], i.brandTwilight[0], i.utilityDanger[1e3], i.utilityDanger[1e3], i.brandTwilight[500], i.brandTwilight[500], i.brandGrabber[200], i.brandTwilight[900], i.brandGrabber[200], i.brandGrabber[200], i.brandTwilight[0], i.utilityDanger[1e3], i.utilityDanger[1200], i.utilityDanger[1200], i.utilityDanger[1e3], i.brandTwilight[800], i.brandTwilight[800], i.brandTwilight[800], i.brandGrabber[1e3], i.brandTwilight[0], i.brandTwilight[400], i.brandTwilight[700], e[200], e[900], e[600], k[1e3], t[1200], t[1e3], e[500], e[800], e[600], k[200], e[0], k[1e3], e[0], t[600], e[800], e[200], e[200], e[400], e[600], t[1e3], e[500], e[200], e[400], t[1e3], e[600], e[900], e[800], e[0], e[400], e[200], e[200], e[500], e[400], e[500], e[400], e[500], e[0], e[800], e[0], e[0], r[1e3], r[1e3], e[900], e[900], e[700], i.utilityDanger[1e3], e[900], e[0], e[200], e[0], e[400], x[100], e[800], x[100], e[0], e[0], e[0], r[1100], r[1300], x[800], x[800], e[600], e[0], i.brandTwilight[200], i.brandTwilight[200], i.accentBlue[500], i.accentBlue[500], i.brandTwilight[200], i.utilityDanger[1e3], i.utilityDanger[1e3], i.brandTwilight[600], i.brandTwilight[600], e[500], e[700], e[600], i.brandTwilight[1e3], i.brandTwilight[800], i.brandTwilight[0], i.brandTwilight[0], i.brandTwilight[100], i.brandTwilight[1e3], i.brandTwilight[800], i.brandTwilight[700], i.accentBlue[1300], i.accentBlue[600], i.utilityDanger[600], i.brandTwilight[300], i.brandTwilight[500], i.brandTwilight[0], i.brandTwilight[0], S.headline, e[0], e[300], e[300], S.headline, e[0], e[300], e[0], e[1e3], e[0], e[1e3], e[0], e[0], e[200], e[0], e[0], e[200], e[1e3], e[0], t[1e3], r[1e3], e[300], d[1e3], e[0], e[0], e[0], e[0], r[1e3], r[1e3], r[1e3], e[0], e[900], e[0], r[1e3], r[100], r[1e3], e[500], r[1e3], e[500], e[800], e[800], e[1e3], e[500], e[400], e[400], e[400], e[200], e[400], r[1e3], i.brandTwilight[500], i.accentBlue[1200], i.accentBlue[100], i.brandTwilight[0], i.brandTwilight[500], i.brandTwilight[400], i.brandTwilight[800], i.accentBlue[1e3], i.brandTwilight[100], i.brandTwilight[400], r[1200], r[1200], r[1e3], r[1200], e[400], e[0], e[800], e[1e3], e[800], e[0], e[400], e[300], r[300], e[600], r[300], r[1200], r[300], e[300], a.placeholder, a["onDisabled-strong"], e[400], r[500], r[600], s["neutral-hover-subtle"], u["primary-subtlest"], u["success-subtlest"], u["caution-subtlest"], u["danger-subtlest"], n.default, n.primary, n.success, n.caution, n.danger, n["primary-strongest"], n["success-strongest"], n["caution-strongest"], n["danger-strongest"], F.scrim.white[20], r[1e3], d[1e3], f[1e3], t[1e3], e[0], r[500], d[500], f[500], t[500], n.onColor, s["neutral-hover-subtle"], u["primary-subtle"], u["success-subtle"], u["caution-subtle"], u["danger-subtle"], a.default, a.subtlest, e[800], e[100], e[600], e[300], x[100], e[100], H[300], H[300], e[100], e[400], e[400], f[100], f[200], f[300], t[100], t[200], t[300], t[800], d[100], d[200], d[300];
export {
  T as B,
  v as Q,
  P as a,
  y as b,
  i as c,
  S as d,
  p as e,
  ho as f,
  o as g,
  c as h,
  a as i,
  u as j,
  z as k,
  h as l,
  n as m,
  mo as n,
  w as o,
  D as p,
  B as r,
  l as s
};
